// Auto-extracted from lib/i18n.js on refactor — do not hand-edit if you
// can help it; keep the same style + comment layout as the other dicts.
const en = {
    appName: "JobGrid",
    tagline: "Personal Application Tracker",
    appliedStatus: "Applied",
    savedStatus: "Not applied yet",
    invitedStatus: "Invited",
    clarificationStatus: "Clarification requested",
    clarificationShortStatus: "Clarification",
    hiredStatus: "Hired",
    rejectedStatus: "Rejected",
    channelLinkedIn: "LinkedIn",
    channelRecruiter: "Recruiter",
    channelOpen: "Open Application",
    typeIncompany: "In-company",
    typeFreelance: "Freelance",
    typeOutsourced: "Outsourced",
    rateHourly: "Hourly",
    rateDaily: "Daily",
    rateMonthly: "Monthly",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving…",
    add: "Add",
    edit: "Edit",
    view: "View",
    delete: "Delete",
    logout: "Logout",
    loading: "Loading…",
    confirmTitle: "Are you sure?",
    confirmConfirm: "Confirm",
    confirmCancel: "Cancel",
    all: "All",

    loginEdition: "Volume I · Search, write & rehearse with AI",
    loginH1A: "A quiet, considered ledger for the",
    loginH1Applications: "applications",
    loginH1B: "you send,",
    loginH1C: "the",
    loginH1Conversations: "conversations",
    loginH1D: "they spark,",
    loginH1E: "and the",
    loginH1Offers: "offers",
    loginH1F: "that follow.",
    loginBody:
      "Save a URL — JobGrid archives the description in case the listing disappears. Track status, channel, rate, recruiter, interview dates and notes. One ledger. Nothing to forget.",
    loginContinueGoogle: "Continue with Google",
    loginGoogleSignin: "Sign in with Google",
    loginGoogleRegister: "Register with Google",
    emailAuthOr: "or with email",
    emailAuthEmail: "Email address",
    emailAuthPassword: "Password",
    emailAuthChoosePassword: "Choose a password",
    emailAuthConfirmPassword: "Confirm password",
    emailAuthNewPassword: "New password",
    emailAuthPwHint: "At least 8 characters, with letters and digits.",
    emailAuthLoginCta: "Sign in",
    emailAuthRegisterCta: "Create account",
    emailAuthTabRegister: "New account",
    emailAuthTabSignin: "Existing account",
    emailAuthVerifyCta: "Verify",
    emailAuthForgotCta: "Send reset code",
    emailAuthResetCta: "Set new password",
    emailAuthForgotLink: "Forgot password?",
    emailAuthRegisterLink: "No account yet?",
    emailAuthResendLink: "Resend",
    emailAuthBackToLogin: "Back to sign in",
    emailAuthCodeLabel: "6-digit code",
    emailAuthVerifyIntro: "We sent a code to",
    emailAuthForgotIntro: "No worries — enter your email and we'll send a 6-digit reset code.",
    emailAuthResetIntro: "Enter the code we just emailed to",
    emailAuthCodeSent: "Verification code sent — check your inbox.",
    emailAuthCodeResent: "New code on its way.",
    emailAuthResetSent: "Reset code sent (if the address is known).",
    emailAuthResetOk: "Password set — welcome back.",
    emailAuthWelcome: "Welcome to JobGrid.",
    emailAuthNeedsVerify: "Please verify your email first.",
    emailAuthMismatch: "Passwords don't match.",
    emailAuthLoginFailed: "Sign-in failed.",
    emailAuthRegisterFailed: "Registration failed.",
    emailAuthVerifyFailed: "Invalid or expired code.",
    emailAuthResetFailed: "Password reset failed.",
    emailAuthGeneric: "Something went wrong, please try again.",
    loginDisclaimer: "By continuing you agree to keep showing up for yourself.",
    loginInThisIssue: "In this issue",
    loginItem1T: "Archive the description",
    loginItem1D: "Paste the URL — the body of the listing is saved alongside it.",
    loginItem2T: "Track every channel",
    loginItem2D: "LinkedIn, recruiter (with name), or open application — all in one place.",
    loginItem3T: "Rate, type, and terms",
    loginItem3D: "EUR rates for in-company, outsourced, and freelance. Selectable hourly, daily, or monthly.",
    loginItem4T: "Interviews and notes",
    loginItem4D: "Schedule, contacts, and personal observations stay with the entry.",
    loginLegend: "Status legend",
    loginFooterL: "Volume I · MMXXVI",
    loginFooterR: "Set in Cormorant Garamond & Satoshi",
    languageLabel: "Language",
    languageUiSection: "App language",
    languageAiSection: "AI generates in 8 languages",
    languageAiHint: "Keep your CV in Dutch and generate the cover letter in any target language.",
    // Homepage USP banner
    langUspTitle: "Apply in 8 languages — from your own",
    langUspBody: "Your CV stays in Dutch, but AI generates your cover letter, interview prep and public CV in Nederlands, English, Deutsch, Français, Español, Polski, Türkçe or العربية. Perfect for international applications.",

    dashOverviewTitle: "Application overview",
    dashHeading1: "application",
    dashHeadingN: "applications",
    dashSubtitle: "The Search Ledger",
    dashAddApplication: "Add Application",
    dashSearch: "Search title or company…",
    dashLabelStatus: "Status",
    dashLabelChannel: "Channel",
    dashLabelType: "Type",
    dashLabelSort: "Sort by",
    dashSortRecent: "Date · newest first",
    dashSortOldest: "Date · oldest first",
    dashSortMatchDesc: "Match score · high → low",
    dashSortMatchAsc: "Match score · low → high",
    dashColMatch: "Match",
    dashColMatchHint: "AI match score based on your CV vs. the vacancy. Click a row to see the full insight.",
    dashMatchNotYet: "Open this vacancy to generate an AI match insight",
    dashBulkInsightsBtn: "AI insights for all",
    dashBulkInsightsBusy: "Generating…",
    dashBulkInsightsHint: "Generate an AI match score for every active vacancy that doesn't have one yet (max 15 per click).",
    dashBulkInsightsDone: "{n} insights generated",
    dashBulkInsightsMore: "{n} vacancies still to do",
    dashBulkInsightsAlerts: "{n} strong matches emailed",
    dashBulkInsightsFailed: "Bulk generation failed — please try again later.",
    // Match-alert preferences
    prefMatchAlertsEyebrow: "Strong-match alerts",
    prefMatchAlertsTitle: "Email me when AI Match Insight scores ≥ threshold",
    prefMatchAlertsBody: "The moment JobGrid finds a vacancy that fits your CV, we email you a short note with the score and the top reasons. Each vacancy triggers at most one alert.",
    prefMatchAlertsToggle: "Enable alerts",
    prefMatchAlertThreshold: "Alert threshold",
    prefMatchAlertSaved: "Preference saved",
    dashLoading: "Loading applications…",
    dashEmptyTitleBlank1: "The page is",
    dashEmptyTitleBlank2: "blank",
    dashEmptyTitleNo1: "No",
    dashEmptyTitleNo2: "matches",
    dashEmptyBlankBody: "Add your first application — paste a URL or fill out the form.",
    dashEmptyNoBody: "Adjust filters to see results.",
    dashEmptyAddFirst: "Add Your First",
    dashColPosition: "Position",
    dashColCompany: "Company",
    dashColStatus: "Status",
    dashColDate: "Date",
    dashColChannel: "Channel",
    dashColActions: "Actions",
    dashActionsMenu: "Action menu",
    dashConfirmDelete: "Delete this application?",
    dashDeleted: "Application deleted",
    dashViewActive: "Active",
    dashViewArchive: "Archive",
    dashArchive: "Archive application",
    dashUnarchive: "Restore to active",
    dashArchived: "Moved to archive",
    dashUnarchived: "Restored as active",
    dashArchiveFailed: "Could not archive. Please try again.",
    dashArchiveNoticeEyebrow: "Archive · one-time notice",
    dashArchiveNoticeTitle: "Applications are kept for max. 1 year",
    dashArchiveNoticeBody: "Once you archive an application it stays visible in your archive for 365 days. After that it is permanently deleted automatically. You can always restore archived items to 'Active' as long as they're still in the archive.",
    dashArchiveNoticeAccept: "I agree",
    dashArchiveRetentionShort: "Kept for max. 1 year · then auto-deleted",
    dashBulkSelect: "Select application",
    dashBulkDeselect: "Deselect application",
    dashBulkSelectPage: "Select everything on this page",
    dashBulkDeselectPage: "Deselect everything on this page",
    dashBulkSelectedOne: "application selected",
    dashBulkSelectedN: "applications selected",
    dashBulkArchiveCta: "Archive selected",
    dashBulkUnarchiveCta: "Restore selected",
    dashBulkClear: "Clear selection",
    dashBulkArchived: "{count} applications archived",
    dashBulkUnarchived: "{count} applications restored",
    dashArchiveExportPdfHint: "Download your archive as PDF (A4 landscape)",
    dashArchiveExportXlsxHint: "Download your archive as an Excel file",
    dashArchiveExporting: "Working…",
    dashArchiveExportDone: "Archive export downloaded",
    dashArchiveExportFailed: "Export failed — please try again.",
    dashLoadFailed: "Failed to load jobs",
    dashDeleteFailed: "Failed to delete",

    bmTitle: "Favorite Job Sites",
    bmSubtitle: "Quick access to your trusted sources",
    bmAdd: "Add",
    bmAdding: "Adding…",
    bmName: "Name",
    bmNamePh: "e.g. LinkedIn Jobs",
    bmUrl: "URL",
    bmUrlPh: "https://…",
    bmOpen: "Open",
    bmOpenNew: "Open in new tab",
    bmRemove: "Remove",
    bmEmpty: "No favorites yet. Add the job sites you visit often.",
    bmConfirmDelete: "Delete this bookmark?",
    bmCreated: "Bookmark saved",
    bmDeleted: "Bookmark removed",
    bmCreateFailed: "Failed to save bookmark",
    bmDeleteFailed: "Failed to delete",
    bmLoadFailed: "Failed to load bookmarks",
    bmRequired: "Name and URL are required",

    // CV & Interview prep
    cvTitle: "My CV",
    cvSubtitle: "Central CV — used for interview prep when no per-application CV is provided",
    cvUpload: "Upload CV",
    cvUploading: "Uploading…",
    cvReplace: "Replace",
    cvRemove: "Remove",
    cvNone: "No CV uploaded yet.",
    cvUploaded: "CV saved",
    cvDeleted: "CV removed",
    cvUploadFailed: "CV upload failed",
    cvHint: "PDF or DOCX, max 5 MB",
    cvCentralTitle: "Central CV — pick source",
    cvCentralHint: "Select one of your CV variants. It is used for interview prep and criterion matching when no CV is uploaded per application.",
    cvCentralNone: "Use uploaded CV file above",
    cvCentralUnnamed: "(unnamed)",
    cvCentralSaved: "Central CV updated",
    cvCentralSaveFailed: "Could not update central CV",
    cvUpdatedAt: "Updated",
    cvConfirmDelete: "Delete this CV?",

    prepButton: "Prep",
    prepTitle: "Interview Preparation",
    prepFor: "for",
    prepGenerate: "Generate preparation",
    prepRegenerate: "Regenerate",
    prepGenerating: "Generating (30-60 sec)…",
    prepGeneratedAt: "Generated at",
    prepUsingCentralCv: "Based on your central CV",
    prepUsingJobCv: "Based on the CV specific to this application",
    prepNoCv: "No CV — add one for better results",
    prepUploadJobCv: "CV for this application",
    prepDownloadPdf: "Download PDF",
    prepPrint: "Print",
    prepEmail: "Email",
    prepWhatsapp: "WhatsApp",
    prepIncludeCv: "Include CV",
    prepIncludeCvHint: "Only if your CV is a PDF — DOCX will be skipped",
    prepEmailSubject: "Interview preparation — {company}",
    prepEmailBody: "Hello,\n\nAttached is the interview preparation for my application at {company} ({job_title}).\n\nKind regards,",
    prepWhatsappText: "Interview preparation for {company} — {job_title}",
    prepShareUnsupported: "File sharing not supported in this browser — PDF will download instead.",
    prepDownloading: "Building PDF…",
    prepShareHint: "Save, print, email, or share via WhatsApp",
    prepNone: "No preparation generated yet. Click above to start.",
    prepFailed: "Generation failed — please retry",
    prepLangMismatch: "This preparation was generated in {stored}. Click 'Regenerate' to remake it in {current}.",
    prepClose: "Close",
    prepSectionIntro: "Introduction",
    prepSectionMission: "What the company stands for",
    prepSectionActivities: "What the company does",
    prepSectionMedia: "In the media",
    prepSectionCvFit: "How my CV aligns",
    prepSectionCompetencies: "Competencies and requirements",
    prepSectionPitch: "Short Pitch",
    prepSectionQuestions: "Questions to ask",
    prepSectionTalking: "Talking points",
    prepSectionClosing: "Closing advice",

    addSheetEyebrow: "New entry",
    addSheetTitle: "Add Application",
    addSec1: "I · Source",
    addSec2: "II · The Position",
    addSec3: "III · Calendar",
    addSec4: "IV · Description (archived)",
    addSec5: "V · Notes",
    addUrl: "Job URL",
    addScrape: "Scrape",
    addScraping: "Scraping…",
    addScrapeHelp:
      "Paste any job posting URL. We will try to extract title and description. Edit or paste manually below.",
    addPaste: "Paste",
    addPasteHint: "Paste URL from clipboard",
    addPasted: "URL pasted from clipboard.",
    addPasteEmpty: "Your clipboard is empty — copy a URL first.",
    addPasteDenied: "Could not access clipboard — please copy and paste manually (Ctrl/⌘+V).",
    addPosition: "Position *",
    addCompany: "Company",
    addCompanyPlaceholder: "Company name (optional)",
    optionalLabel: "optional",
    addStatus: "Status",
    addDate: "Date Applied",
    addChannel: "Channel *",
    addRecruiterName: "Recruiter Name *",
    addJobType: "Job Type",
    addRate: "Rate (€)",
    addRateType: "Rate Type",
    addLocation: "Location",
    addSalary: "Salary Range",
    addContact: "Contact Person",
    addContactPh: "Name · Email · Phone",
    addInterviewDates: "Interview Dates",
    addHoursPerWeek: "Hours per week",
    addHoursPerWeekPh: "e.g. 40",
    addDescription: "Job Description",
    addDescriptionPh: "Paste manually if scraping failed…",
    addNotesLabel: "Personal Notes",
    addNotesPh: "What did you notice? Who reached out?",
    addSaveApplication: "Save Application",
    addRequired: "Position and Company are required",
    addRecruiterRequired: "Recruiter Name is required",
    addUrlFirst: "Enter a URL first",
    addScrapeOk: "Scraped successfully",
    addScrapeFailed: "Could not scrape: {err}. Paste manually below.",
    addScrapeError: "Scrape failed. Paste manually below.",
    addCreated: "Application added",
    addSaveFailed: "Failed to save",

    detailEyebrow: "Entry №",
    detailMoreDetails: "More details",
    detailExpand: "Expand",
    detailCollapse: "Collapse",
    detailCurrent: "Current Status",
    detailDate: "Date Applied",
    detailDateEdit: "Click to change date",
    detailDateUpdated: "Application date updated",
    detailDateFailed: "Could not update the application date",
    detailChangeStatus: "Change Status",
    detailMeta: "Meta",
    detailCalendar: "Calendar",
    detailNoInterviews: "No interviews scheduled.",
    detailNotes: "Notes",
    detailNoNotes: "No notes.",
    detailDescription: "Description (archived)",
    // AI Match Insight (job detail sheet)
    miEyebrow: "AI MATCH INSIGHT · WHY YOU FIT",
    miVerdict_strong: "Strong match",
    miVerdict_good: "Good match",
    miVerdict_mixed: "Mixed signals",
    miVerdict_weak: "Weak match",
    miStrengthsHeader: "What works for you",
    miGapsHeader: "Watch-outs",
    miRefreshBtn: "Regenerate",
    miRefreshHint: "Generate a fresh AI summary based on your current CV",
    miGeneratedAt: "Generated at",
    miErrGeneric: "Couldn't fetch the insight — please try again later.",
    // Similar-jobs strip (Insight Compare)
    similarStripEyebrow: "ALSO WORTH A LOOK · SIMILAR MATCHES",
    similarStripHint: "This vacancy scores {s}/100. Other vacancies in your list at a similar level:",
    detailNoDescription: "No description saved.",
    detailMetaChannel: "Channel",
    detailMetaJobType: "Job Type",
    detailMetaRate: "Rate",
    detailMetaLocation: "Location",
    detailMetaSalary: "Salary Range",
    detailMetaContact: "Contact Person",
    detailMetaHours: "Hours per week",
    dashColContract: "Contract",
    detailUpdated: "Updated",
    detailUpdateFailed: "Failed to update",
    detailStatusToast: "Status: {status}",
    detailStatusFailed: "Failed to update status",
    // "Clarification requested" flow.
    detailClarifyEyebrow: "Employer asked for clarification",
    detailClarifyAskedAt: "Asked on {when}",
    detailClarifyNoNote: "No note yet — add the employer's question below.",
    detailClarifyCta: "Address clarification in Match-Improve Wizard",
    detailClarifyCtaHint: "Opens the linked cover letter and launches the wizard so you can weave the requested requirement into your CV/letter.",
    detailClarifyEditNote: "Edit note",
    detailClarifyNoLetter: "No cover letter linked to this application yet. Generate one first.",
    detailClarifySaved: "Application marked 'Clarification requested'",
    detailClarifyDialogEyebrow: "New status",
    detailClarifyDialogTitle: "What does the employer want clarified?",
    detailClarifyDialogBody: "Note the question or missing detail the employer raised. We'll use this text in the Match-Improve Wizard to sharpen your CV and letter.",
    detailClarifyDialogPh: "E.g. 'The HR manager asked about concrete experience as scrum master at fintech clients.'",
    detailClarifyDialogHint: "This note is only visible to you.",
    detailClarifyDialogSubmit: "Mark as clarification requested",
    detailLoadFailed: "Failed to load job",
    detailUrlLabel: "URL",

    // CV panel tabs
    cvTabUpload: "CV File",
    cvTabOverview: "CV overview",
    cvTabBuilder: "Resume Builder",
    cvOvVariantsTitle: "Your CVs",
    cvOvEmpty: "No CVs created yet.",
    cvOvEmptyHint: "Head to the Resume Builder to create your first CV.",
    cvOvClickToEdit: "Click to edit",
    cvOvSetDefaultCta: "Mark as default",
    cvOvUnsetDefaultCta: "Remove default",
    cvOvSetDefault: "Default CV updated",
    cvOvUnsetDefault: "Default CV removed",
    cvOvDefault: "Default",
    cvOvCopyBadge: "Copy",
    cvOvCopyBadgeTitle: "This CV is a copy of another variant",
    cvOvDupCountTitle: "Duplicated {count}×",
    cvOvVacancyBadgeTitle: "Generated for vacancy: {title}",
    cvOvUpdatedAt: "Updated {date}",
    cvOvColName: "Name",
    cvOvColUpdated: "Updated",
    cvOvUploadedBadge: "Self-uploaded",
    cvOvUploadedTitle: "Uploaded external file — not editable",
    cvOvUploadedHint: "External PDF/DOCX file · not editable",
    cvOvUploadedFallbackName: "Uploaded CV",
    cvOvUploadedConfirmDelete: "Are you sure you want to delete the uploaded CV?",
    cvOvUploadedDeleted: "Uploaded CV deleted",
    cvTabLetters: "Motivation Letters",

    // Resume builder
    rbTitle: "Resume Builder",
    rbSubtitle: "Build and manage multiple resume variants with AI assistance",
    rbVariants: "Variants",
    rbNewNamePh: "Variant name, e.g. Project Lead — general",
    rbCreateEmpty: "Blank",
    rbImportCentral: "From central CV",
    rbImportFile: "From file",
    rbImporting: "AI is reading your CV… (20-40 sec)",
    rbNoVariants: "No resume variants yet. Create one or import your current CV.",
    rbConfirmDelete: "Delete this resume variant?",
    rbDeleted: "Variant deleted",
    rbDuplicate: "Duplicate",
    rbDuplicated: "Variant duplicated",
    rbConfirmDeleteWithLetters: "This CV is linked to {count} cover letter(s):",
    rbConfirmDeleteLettersHint: "The letter itself stays, but loses its CV attachment. Continue?",
    rbUndone: "Deletion undone",
    undo: "Undo",
    rbCreated: "Variant created",
    rbImported: "CV imported — review the fields",
    rbImportFailed: "Import failed",
    rbNameRequired: "Give the variant a name first",
    rbSave: "Save",
    rbSaved: "Resume saved",
    rbSaveFailed: "Save failed",
    rbSelectVariant: "Select or create a variant on the left to edit.",
    rbPdfNl: "PDF (NL)",
    rbPdfEn: "PDF (EN)",
    rbPdfBoth: "PDF (Both)",
    rbPdfDownload: "Download PDF",
    rbPdfLang: "Language",
    rbLangNl: "Dutch",
    rbLangEn: "English",
    rbLangDe: "German",
    rbLangFr: "French",
    rbLangEs: "Spanish",
    rbPdfGenerating: "Generating PDF…",
    rbPdfHint: "First generation per language may take ±30 sec (AI translation)",
    rbPdfFailed: "PDF generation failed",
    rbSecPersonal: "Personal details",
    rbSecProfile: "Profile",
    rbSecSkills: "Skills",
    rbSecExperience: "Work experience",
    rbSecEducation: "Education",
    rbSecExtra: "Extracurricular activities",
    rbSecReferences: "References",
    rbFullName: "Full name",
    rbJobTitle: "Title / role",
    rbAddress: "Address",
    rbNationality: "Nationality",
    rbPhone: "Phone",
    rbEmail: "Email",
    rbLinkedin: "LinkedIn",
    rbProfilePh: "Short professional summary…",
    rbProfileWizard: "Profile wizard",
    rbSkillPh: "e.g. Stakeholder management",
    rbAddExperience: "Add experience",
    rbAiOptimize: "AI suggestion",
    rbEduTitle: "Degree / course",
    rbEduInstitution: "Institution",
    rbEduYear: "Year",
    rbAddEducation: "Add education",
    rbAddExtra: "Add activity",
    rbReferencesPh: "e.g. References available upon request",
    // References multi-select
    rbRefPickPh: "Pick references — or leave empty for 'References on request'",
    rbRefSelectedCount: "{n} reference(s) selected",
    rbRefRemove: "Remove",
    rbRefLoading: "Loading…",
    rbRefEmpty: "No approved references yet. Add them under Settings → References.",
    rbRefAllPicked: "All available references are already selected.",
    rbRefDefault: "No selection → the PDF shows 'References available on request' at the bottom.",
    rbRefSelectedHint: "Only the fields the reference approved for sharing will appear on the PDF.",
    rbRefDragHint: "Drag to reorder",
    rbSkillDragHint: "Drag to sort skills — top item lands first on the PDF",
    rbDragHint: "Drag to reorder this row",
    rbSecPortfolioQr: "Portfolio QR",
    rbPortfolioQrHelp: "Pick a portfolio to show as a QR code in the bottom-left of the CV. Recruiters scan and jump straight to your online work.",
    rbPortfolioQrEmpty: "No portfolios yet. Head to the Portfolio menu item to create one.",
    rbPortfolioQrNone: "No QR",
    rbPortfolioQrPreview: "This is the QR that lands on your CV",
    rbPortfolioQrPreviewBody: "The QR shows up in the bottom-left of the CV. Recruiters scan and jump straight to your public portfolio page.",
    rbCoverItem: "Featured project (optional)",
    rbCoverItemHelp: "Append one portfolio project as an extra spread at the end of the CV — first image becomes the hero visual.",
    rbCoverItemNone: "No featured project",
    rbCoverItemEmpty: "Add a project to this portfolio before you can feature one on your CV.",
    rbRefPreviewEyebrow: "Preview — how it appears on the PDF",
    rbRefPreviewDefault: "References available on request",

    // PopoutTextarea
    popoutTitle: "Edit",
    popoutExpand: "Expand editor",
    popoutSave: "Save",
    popoutCancel: "Cancel",
    popoutSaved: "Saved",
    popoutShortcut: "⌘/Ctrl + Enter = save",
    popoutChars: "{n} characters",
    rbRole: "Role title",
    rbCompany: "Company",
    rbLocation: "Location",
    rbFrom: "From",
    rbUntil: "Until",
    rbCurrentRole: "Present (ongoing)",
    rbDescriptionLabel: "Description",
    rbAchievementsLabel: "Key achievements",
    rbAchievementsHint: "Concrete outcomes from this role. One per line, each starting with '•'. Appears on your CV PDF below the description.",
    rbAchievementsPh: "• Led a team of 8 developers to successful delivery of…\n• Reduced infrastructure costs by 30% through…",
    rbAchievementsSuggestCta: "AI suggest",
    rbAchievementsPolishCta: "AI rewrite",
    rbAchievementsBusy: "AI thinking…",
    rbAchievementsSuggestHint: "AI drafts 3-5 concrete achievements based on this role + description. Uses only facts already in your description.",
    rbAchievementsSuggestNeedsDesc: "Fill in role title + description first — then AI can suggest achievements.",
    rbAchievementsPolishHint: "AI rewrites your current text into STAR bullets without changing facts.",
    rbAchievementsPolishNeedsText: "Add some text first — then AI can polish it.",
    rbAchievementsSuggestDone: "AI drafted achievements — tweak as you like.",
    rbAchievementsPolishDone: "Text polished.",
    rbAchievementsUndo: "Undo",
    rbAchievementsFail: "AI action failed — please try again.",
    rbAchievementsHintTitle: "Why achievements lift your match score",
    rbAchievementsHintBody: "Descriptions show WHAT you did. Achievements show what it delivered — concrete and measurable. Recruiters and AI match scores weigh outcomes more than tasks.",
    rbAchievementsHintExOldLabel: "Description only:",
    rbAchievementsHintExOld: "I was responsible for the cloud migration.",
    rbAchievementsHintExNewLabel: "+ With outcome:",
    rbAchievementsHintExNew: "Led the migration of 12 legacy systems to AWS in 6 months and cut infrastructure costs by 30%.",
    rbAchievementsHintFooter: "Tip: let 'AI suggest' distil 3-5 bullets from your current description, then polish them with 'AI rewrite'. Stays blank if you don't fill it — no header on your CV PDF.",
    rbNoPeriod: "Period unknown",

    // Wizards
    wizExpTitleAdd: "Experience Wizard",
    wizExpTitleOptimize: "AI suggestion for this experience",
    wizStep1: "Step 1 · When and where",
    wizStep2: "Step 2 · What did you do?",
    wizStep3: "Step 3 · AI proposal",
    wizWhatLabel: "What did you do there?",
    wizWhatPh: "Describe in your own words what you did, your responsibilities and results…",
    wizNext: "Next",
    wizBack: "Back",
    wizGenerate: "Generate proposal",
    wizGenerating: "AI is writing… (10-30 sec)",
    wizRegenerate: "Regenerate",
    wizProposalHint: "Edit the text or keep it as is.",
    wizProposalPlaceholder: "The AI proposal will appear here in a moment — you can still tweak it afterwards…",
    wizEmptyResult: "The AI didn't return any text",
    wizEmptyResultHelp: "This can happen if your answers were too short or the model briefly didn't respond. Click 'Regenerate' to fetch a fresh proposal.",
    wizKeepSave: "Keep & save",
    wizFailed: "Generation failed — please retry",
    wizExpRequired: "Company and role title are required",
    wizWhatRequired: "Describe what you did first",
    wizProfileTitle: "Profile Wizard",
    wizProfileMode: "How do you want to build the profile?",
    wizProfileFromExp: "Based on my work experiences",
    wizProfileFromExpHint: "AI distills the common thread from your experiences",
    wizProfileQuestions: "Through a few questions",
    wizProfileQuestionsHint: "Who you are, personality and skills",
    wizWho: "Who are you professionally?",
    wizWhoPh: "e.g. Experienced project lead with a passion for people and processes…",
    wizPersonality: "Personality",
    wizPersonalityPh: "e.g. reliable, communicative, results-driven…",
    wizSkillsQ: "Key skills",
    wizSkillsQPh: "e.g. stakeholder management, Agile, change programs…",
    wizNoExperiences: "No work experiences yet — choose the questions route",
    wizAnswerOne: "Answer at least one question",

    // Letters
    ltTitle: "Motivation Letters",
    ltSubtitle: "Letter + requirement validation, generated from a stored resume",
    ltNew: "New letter",
    ltEmpty: "No letters yet. Start the wizard to generate your first motivation letter.",
    ltConfirmDelete: "Delete this letter?",
    ltDeleted: "Letter deleted",
    ltLoadFailed: "Failed to load letters",
    ltRetention: "Retention period",
    ltRetentionHint: "Letters older than this period are removed automatically",
    ltRetention30: "30 days",
    ltRetention90: "90 days (default)",
    ltRetention180: "180 days",
    ltRetention365: "1 year",
    ltRetentionForever: "Forever",
    ltRetentionSaved: "Retention period saved",
    ltBasedOn: "Based on",
    ltCreatedAt: "Created",
    ltOpen: "Open",
    ltInRegisterBadge: "In tracker",
    ltInRegisterHint: "This letter is linked to a job application — click to open it",
    ltMatchScore: "Match score",
    ltMatchScoreHint: "AI estimate of how well your resume fits this vacancy — hard requirements ~50%, tasks ~30%, soft skills ~20%.",
    mseTrigger: "How is this score calculated?",
    mseTitle: "How does the match-score work?",
    mseIntro: "The AI compares your CV against the vacancy and produces a 0–100 score. Under the hood three components are weighted:",
    mseWeightingTitle: "Weighting",
    mseWeightMust: "Hard requirements — must-haves from the vacancy",
    mseWeightTasks: "Tasks & responsibilities",
    mseWeightSoft: "Soft skills & nice-to-haves",
    mseBandsTitle: "What does my score mean?",
    mseBand90: "Full match on nearly every requirement — apply-ready.",
    mseBand75: "Strong fit with small gaps — usually good enough for an interview invite.",
    mseBand60: "Decent fit, several gaps — using the Match Improvement Wizard is advised.",
    mseBand40: "Weak fit — consider a CV variant more tailored to this role.",
    mseBandLow: "Poor fit — the vacancy likely doesn't match your profile.",
    mseDisclaimer: "AI estimate based on text analysis. No guarantee of an invitation — recruiters also weigh things outside your CV (motivation, references, timing).",
    mseCtaWizard: "Start Match Improvement Wizard",
    mseCtaChooseCv: "Consider a different CV variant",
    mseCtaChooseCvHint: "Open 'My CVs' in the sidebar and pick a variant that fits this vacancy better — or create a new one.",
    mseCtaChooseCvBtn: "View my CV variants",
    mseNavToastTitle: "Pick a CV variant for «{job}»",
    mseNavToastFallback: "Look for a variant that overlaps more with the vacancy requirements.",
    pjhTitle: "Missing the right variant for «{job}»?",
    pjhOpenBuilder: "Open the CV Generator",
    pjhDismiss: "Dismiss this tip",
    pjhGenerate: "Generate AI variant now",
    pjhGenerating: "AI is writing…",
    pjhGenerated: "New variant «{name}» created — open to edit.",
    pjhGenerateFailed: "AI could not create the variant — please retry.",
    aiInfoTitle: "This variant was AI-tailored to the vacancy «{job}»",
    aiInfoSubtitle: "AI rewrote {n} text sections based on your existing CV. Every change is backed by verbatim evidence from your own CV — no fabricated experience.",
    aiInfoShow: "Show the changes",
    aiInfoHide: "Hide the changes",
    aiInfoDismiss: "Dismiss this explanation panel",
    aiInfoProfileLabel: "Profile",
    aiInfoExperience: "Experience",
    aiInfoBefore: "Original",
    aiInfoAfter: "AI rewrite",
    aiInfoGrounded: "Evidence from your CV",
    aiInfoRevert: "Restore original",
    aiInfoRevertHint: "Restore this section to the original text from your source CV",
    aiInfoReverted: "Section restored to original — don't forget to save",
    mseCtaCongrats: "This letter is ready to send — your CV covers nearly every requirement. Good luck!",
    ltImproveCta: "Improve this match",
    ltImproveBadge: "Improve",
    ltImproveUsage: "{r} of {l} Match-AI actions left this month",
    ltImproveTitle: "Match advice",
    ltImproveSubtitle: "Concrete steps to raise your score",
    ltImproveLoading: "AI is analyzing your resume against the vacancy…",
    ltImproveFailed: "Failed to generate advice — please retry",
    ltImproveNow: "Now",
    ltImproveProjected: "Potential",
    ltImproveImpactUnit: "points",
    ltImproveImpactHint: "Estimated extra match points if you apply this tip",
    ltImproveDisclaimer: "AI suggestions based on your resume and this vacancy — your critical judgement still applies.",
    ltImproveCat_skills: "Skills",
    ltImproveCat_experience: "Experience",
    ltImproveCat_wording: "Wording",
    ltImproveCat_learning: "Learning path",
    ltRewriteCta: "Rewrite resume",
    ltRewriteCtaTitle: "Let AI update your resume",
    ltRewriteCtaHint: "Based on the wording and experience tips above, the AI drafts a proposal — you review it side by side with your current text and accept or reject.",
    ltRewriteTitle: "Proposed resume text",
    ltRewriteSubtitle: "Review before you accept",
    ltRewriteHint: "Only your profile summary and experience descriptions are rewritten — facts, dates and roles stay unchanged.",
    ltRewriteLoading: "AI is drafting text improvements…",
    ltRewriteFailed: "Failed to generate a rewrite — please retry",
    ltRewriteApplyFailed: "Applying the rewrite failed — your resume was not changed",
    ltRewriteApplied: "Resume updated with AI advice",
    ltRewriteAppliedFork: "New CV variant created: {name}",
    ltRewriteFork: "New variant",
    ltDetachTitle: "This letter uses your default CV",
    ltDetachBody: "Any change to “{name}” (manual or via AI for another vacancy) will now instantly change what you download here. Detach to lock in a separate variant — your default CV stays untouched.",
    ltDetachCta: "Detach",
    ltEnrichTitle: "Enrich this letter",
    ltEnrichHint: "Add extra info (e.g. a project or achievement) — the AI weaves it into a fresh version of the letter and validation.",
    ltEnrichPlaceholder: "e.g. 'I also did 2 years of Kubernetes at X' or 'emphasize my stakeholder management'…",
    ltEnrichCta: "Weave in & regenerate",
    ltEnrichBusy: "Working…",
    ltEnrichSuccess: "New version of the letter generated",
    ltEnrichFailed: "Could not regenerate — please try again",
    ltEnrichPreviewEyebrow: "New version",
    ltEnrichPreviewTitle: "Confirm the new letter",
    ltEnrichPreviewCurrent: "Current version",
    ltEnrichPreviewNew: "AI-generated version",
    ltEnrichPreviewApply: "Apply",
    ltEnrichPreviewReject: "Cancel",
    ltEnrichPreviewFooterHint: "Applying updates the letter and re-renders the PDF.",
    ltEnrichPreviewEditHint: "You can hand-tune the new version before applying.",
    ltEnrichPreviewEditedBadge: "Manually edited",
    ltDetachBusy: "Detaching…",
    ltDetachConfirm: "Create a dedicated CV variant for this vacancy? Your default CV stays unchanged.",
    ltDetachSuccess: "Separate variant created: {name}",
    ltDetachFailed: "Detach failed",
    ltRewriteAccept: "Apply to resume",
    ltRewriteApplying: "Applying…",
    ltRewriteReject: "Discard",
    ltRewriteBefore: "Current text",
    ltRewriteAfter: "Proposed text",
    ltRewriteProfileLabel: "Profile summary",
    ltRewriteExpLabel: "Work experience",
    ltRewriteEmpty: "No text improvements found — the advice focuses on learning paths or skills.",
    ltRewriteSourcesCta: "Sources",
    ltRewriteSourcesTitle: "Grounded in your CV",
    ltRewriteSourcesHint: "Show the exact CV lines this rewrite is grounded in",
    ltRewriteCompensatesLabel: "Compensates",
    ltRewriteCompensatesHint: "This experience demonstrably covers this vacancy requirement",
    ltRewriteEditCta: "Edit",
    ltRewriteEditHint: "Take the proposal and tweak it to match your voice",
    ltRewriteEditSave: "Save",
    ltRewriteEditCancel: "Cancel",
    ltRewriteEditedLabel: "Edited",
    ltRewriteEditedHint: "This text has been changed from the AI proposal",
    ltRewriteResetCta: "Restore original",
    ltRewriteResetHint: "Revert to the original AI suggestion",
    ltRewriteTitleSwapEyebrow: "Professional title updated",
    ltRewriteTitleSwapAsk: "This CV variant's title is automatically aligned with the vacancy. Uncheck to keep the original.",
    ltRewriteTitleSwapHint: "Only this variant is changed — your default CV stays untouched.",
    ltTipContextCta: "Add context to this criterion",
    ltTipContextEdit: "Edit context",
    ltTipContextTitle: "Extra context",
    ltTipContextHint: "What do you know that the AI can't get from your CV? Like experience with a specific client, or a result you didn't list.",
    ltTipContextClose: "Close",
    ltTipContextPh: "Tell the AI what you did — or tap the mic to speak it…",
    ltTipContextMicStart: "Start speech-to-text",
    ltTipContextMicStop: "Stop speech-to-text",
    ltTipContextMicRecording: "🔴 Listening…",
    ltTipContextExpLabel: "Which work experience does this apply to? (multi-select)",
    ltTipContextBadge: "Context",
    ltTipContextBadgeHint: "This tip has your extra context that the AI will use",
    ltTipEmployerBadge: "From employer",
    ltTipEmployerBadgeHint: "This tip is the clarification the employer asked for. The AI weaves it into your CV/letter automatically.",
    ltMatchHistoryTitle: "Match-score history",
    ltRewriteTipScoresEyebrow: "Fit per criterion",
    ltRewriteTipScoresTitle: "How well does the rewritten CV now cover each criterion?",
    ltRewriteTipScoresContextNote: "{n} criterion/-ia with your context — the after-score reflects that input.",
    ltRewriteTipScoresContextChipHint: "This criterion-fit was influenced by your context",
    ltRewriteTipScoresAvgLabel: "Total gain",
    ltRewriteTipScoresJumpHint: "Click to scroll to the corresponding rewritten text",
    ltImproveTipFallback: "Tip",

    // Improve-match wizard (nested flow: advice → rewrite → regenerate → result)
    imwTitle: "Match improvement wizard",
    imwSubtitle: "From advice to a higher score in 4 steps",
    imwStepAdvice: "Advice",
    imwStepRewrite: "Rewrite CV",
    imwStepRegen: "New letter",
    imwStepResult: "Result",
    imwBack: "Back",
    imwGoRewrite: "Go to CV rewrite",
    imwApplyAndRegen: "Apply and regenerate letter",
    imwFinish: "Done — close wizard",
    imwRollbackCta: "Roll back",
    imwRollbackBusy: "Rolling back…",
    imwRollbackHint: "Restore the original CV and letter to how they were before this improve round. The temporary variant is removed.",
    imwRollbackDone: "Restored to your original CV and letter.",
    imwRollbackNoop: "Nothing left to roll back.",
    imwRollbackFailed: "Rollback failed — try again or reopen the letter later.",
    imwKeepAnywayCta: "Keep anyway",
    imwKeepAnywayHint: "Keep the new version despite the lower match score. You can fine-tune manually later.",
    imwResultDroppedEyebrow: "Heads up — score dropped",
    imwResultDroppedTitle: "Match score fell by {delta} points",
    imwResultDroppedBody: "The AI rewrite lowered the match score instead of raising it. Decide whether to keep the new version anyway or roll back to your original CV and letter.",
    imwNoRewriteTips: "This round produced no wording or experience tips to change your CV",
    imwRegenLoading: "AI is writing a fresh motivation letter and recalculating the match score…",
    imwRegenPending: "Ready to start",
    imwRegenPatience: "This usually takes 30-60 seconds. Hang tight — we're updating your letter live.",
    imwRegenOvertime: "Taking longer than expected…",
    imwRegenFailed: "Regeneration failed — please retry",
    imwResultBefore: "Before",
    imwResultAfter: "After",
    imwResultDelta: "points",
    imwResultLetterPreview: "New letter preview",
    imwPurpose_advice_title: "What happens here?",
    imwPurpose_advice_body: "The AI compares your resume against the vacancy and produces 4-6 concrete tips with an estimated impact per tip. This step is analysis only — nothing about your resume or letter changes yet.",
    imwPurpose_rewrite_title: "What happens here?",
    imwPurpose_rewrite_body: "The AI drafts text improvements for your profile summary and experience descriptions. Only wording changes; facts, dates and role titles stay exactly as they are. You review the proposal before anything is saved.",
    imwPurpose_regenerate_title: "What happens here?",
    imwPurpose_regenerate_body: "Your resume is now updated. Based on that, the AI writes a fresh motivation letter and recalculates the match score. You'll immediately see how much your score improved.",
    imwPurpose_result_title: "What happens here?",
    imwPurpose_result_body: "Compare your old and new match score, read the new summary and preview the new letter. You can now close the wizard — the updated letter and resume have been saved.",

    ltwTitle: "Motivation Letter Wizard",
    ltwStepLabel: "Step {n} of 5",
    ltwStep1: "The vacancy",
    ltwStep2: "Choose your resume",
    ltwStep3: "Language",
    ltwStep4: "Highlight experiences",
    ltwStep5: "Highlight skills",
    ltwUrl: "Job URL",
    ltwScrape: "Fetch",
    ltwScraping: "Fetching…",
    ltwScrapeOk: "Vacancy fetched",
    ltwScrapeFailed: "Fetch failed — paste the text below",
    ltwJobTitle: "Job title *",
    ltwCompany: "Company *",
    ltwDescription: "Job description",
    ltwDescriptionPh: "Paste the job description here if fetching fails…",
    ltwPickResume: "Which resume should the letter follow?",
    ltwNoResumes: "No resume variants yet — create one in the Resume Builder first.",
    ltwLang: "In which language should the letter be written?",
    ltwLangNl: "Dutch",
    ltwLangEn: "English",
    ltwLangDe: "German",
    ltwLangFr: "French",
    ltwLangEs: "Spanish",
    ltwLangDetecting: "Detecting vacancy language…",
    ltwLangAutoDetected: "Auto-detected from the vacancy text — you can still change it.",
    ltwHighlightExp: "Want to highlight certain experiences EXTRA? Select them.",
    ltwHighlightSkills: "Which skills do you want to emphasize?",
    ltwOptional: "Optional — selecting nothing is fine too",
    ltwNoItems: "No items found in this resume variant.",
    ltwGenerate: "Generate letter + validation",
    ltwGenerating: "AI is writing your letter… (30-60 sec)",
    ltwElapsed: "{s} sec elapsed",
    ltwStageLetter: "1. Drafting letter",
    ltwStageValidation: "2. Validating requirements",
    ltwStageScore: "3. Match score",
    ltwTimeoutEyebrow: "AI is a bit slow",
    ltwTimeoutBody: "The AI server took just a little longer than our edge servers wanted to wait. Your input is preserved — click Retry to resend right away.",
    ltwTimeoutRetry: "Try again",
    ltwAutoRetry: "AI server was slow — resending…",
    ltwDraftRestored: "Draft from your previous session restored",
    ltwDraftClear: "Clear & restart",
    ltwRequired: "Job title and company are required",
    ltwPickResumeFirst: "Choose a resume variant first",
    ltwGenerated: "Letter generated",
    ltwFailed: "Generation failed — please retry",

    ltLetter: "Motivation letter",
    ltLetterHint: "Maximum 1 A4 page — feel free to edit the text",
    ltValidation: "Requirement validation",
    ltMaximize: "Full screen",
    ltMinimize: "Restore window",
    prepDossier: "Used in this application",
    prepDossierCv: "Resume variant",
    prepDossierLetter: "Motivation letter",
    prepDossierCvGone: "variant deleted",
    prepDossierNone: "No motivation letter linked to this application yet.",
    prepDlCv: "Resume (PDF)",
    prepDlLetter: "Letter (PDF)",
    prepDlPackage: "Package (PDF)",
    dashNoResponse: "{days}d no response",
    dashFollowedUp: "Followed up · awaiting reply",
    emwFollowedUpMarked: "Follow-up recorded on the application",
    ltValidationHint: "Per requirement from the vacancy, in first person",
    ltValTitlePh: "Requirement or wish…",
    ltAddValItem: "Add item",
    ltSaved: "Letter saved",
    ltSaveFailed: "Save failed",
    ltDownloads: "Downloads",
    ltDlLangLabel: "Language",
    ltDlLangTranslateNotice: "Letter will be auto-translated from {from} → {to} (cached free for repeat downloads).",
    ltDlPackageZip: "Both languages (ZIP)",
    ltDlPackageZipTitle: "Download the application package in NL and EN bundled as a ZIP.",
    ltDlLangEditTranslation: "Edit translation",
    trEdEyebrow: "Edit translation",
    trEdTitle: "Refine the translation · {source} → {target}",
    trEdSourceLabel: "Source",
    trEdTargetLabel: "Translation (editable)",
    trEdSameLangHint: "You're editing the source text — changes will replace the letter body.",
    trEdCachedHint: "This translation was previously generated. Tweak it and save to freeze the download version.",
    trEdFreshHint: "Freshly generated by AI — review for errors and edit as needed. Save to freeze the download version.",
    trEdFooterHint: "Saving overwrites the {target} version used by downloads and the application package.",
    trEdSaveCta: "Save",
    trEdSaving: "Saving…",
    trEdCancel: "Cancel",
    trEdLoading: "Loading translation…",
    trEdLoadFail: "Failed to load translation",
    trEdSaveFail: "Save failed",
    trEdSaved: "Translation saved",
    trEdEmpty: "Translation cannot be empty",
    ltDlResume: "1 · Resume (PDF)",
    ltDlValidation: "2 · Requirement validation (PDF)",
    ltDlLetter: "3 · Motivation letter (PDF)",
    ltDlBusy: "Working…",
    ltOpenVacancy: "Open vacancy page",
    ltOpenVacancyHint: "Jump straight to the vacancy page to upload your CV and cover letter at the employer",
    ltValPolishCta: "Rewrite into flowing argumentation",
    ltValPolishHint: "AI polishes your text without changing facts",
    ltValPolishTooShort: "Too short — write at least one sentence before asking AI to polish.",
    ltValPolishNoChange: "AI found no improvement — your text already flows.",
    ltValPolishDone: "Text rewritten",
    ltValPolishUndo: "Undo",
    ltValPolishFail: "AI rewrite failed — please try again.",
    ltValPolishBulkCta: "Polish all items",
    ltValPolishBulkHint: "AI rewrites every validation item at once into smooth argumentation, without changing facts.",
    ltValPolishBulkBusy: "AI polishing all items…",
    ltValPolishBulkDone: "{n} validation items rewritten",
    ltValPolishBulkNoChange: "AI found no improvements — your items already read smoothly.",
    ltValPolishBulkFail: "Bulk polish failed — please try again.",
    ltValRegenCta: "Regenerate",
    ltValRegenBusy: "AI analysing requirements…",
    ltValRegenHint: "Regenerate the requirement validation against the linked CV. Pick depth in the menu.",
    ltValRegenNoCv: "No CV linked — attach a CV first to (re)calculate validation.",
    ltValRegenDeepLabel: "Deep (per experience)",
    ltValRegenDeepHint: "AI scans every work experience and, per requirement, names every company + period + concrete example. Best for strong argumentation.",
    ltValRegenConciseLabel: "Concise (1-2 sentences)",
    ltValRegenConciseHint: "Classic style: 1-2 sentences per requirement. Faster to scan, less detail.",
    ltValRegenDone: "{n} validation items regenerated",
    ltValRegenFail: "Regenerate failed — please try again.",
    ltValCompareEyebrow: "Compare",
    ltValCompareTitle: "Compare old vs new requirement-validation",
    ltValCompareBody: "For each requirement pick whether to accept the new version (right), keep the old (left), or fine-tune the new text inline before accepting. By default: everything the AI improved is checked.",
    ltValCompareColOld: "Old (current)",
    ltValCompareColNew: "New (AI proposal)",
    ltValCompareAcceptAll: "Accept all new",
    ltValCompareKeepAll: "Keep all",
    ltValCompareStats: "{acc} accepting · {keep} keeping · {drop} removed",
    ltValCompareUnchanged: "AI left this item unchanged.",
    ltValCompareOldEmptyNetNew: "New item — wasn't there before.",
    ltValCompareNewEmpty: "—",
    ltValCompareAiDropped: "AI dropped this item",
    ltValCompareKeepThis: "Keep old",
    ltValCompareTakeNew: "Take new",
    ltValCompareApply: "Apply",
    ltValCompareApplied: "{n} validation items updated",
    ltValCompareApplyFail: "Save failed — please try again.",
    ltDlOverlayResume: "Downloading CV…",
    ltDlOverlayLetter: "Downloading motivation letter…",
    ltDlOverlayValidation: "Downloading requirement validation…",
    ltDlOverlayPackage: "Building application package…",
    ltDlOverlayPackageZip: "Building bilingual package…",
    ltDlOverlayGeneric: "Preparing file…",
    ltDlOverlayHint: "Hang tight — this may take a few seconds",
    ltDlResumeMissing: "The linked resume variant no longer exists",
    ltToRegister: "Add to application overview",
    ltToRegisterHint: "Adds this application to your application overview for next steps",
    ltInRegister: "In the application overview ✓",
    ltToRegisterOk: "Added to the application overview",
    ltToRegisterFailed: "Failed to add",
    dashLetterButton: "Motivation letter",

    // Sidebar navigation + new job wizard
    navOverview: "Overview",
    navMyCvs: "My Resumes",
    navMyLetters: "My Motivation Letters",
    navBookmarks: "Favorite sites",
    navReferences: "References",
    refsTitle: "References",
    refsHeading: "Manage your references",
    refsSubtitle: "Choose who you list as a reference. Ask for their approval by email and pick which fields are shared. Your public CV always shows only 'References available on request'.",
    refsAddTitle: "New reference",
    refsFieldName: "Name",
    refsFieldEmail: "Email address",
    refsFieldPhone: "Phone number",
    refsFieldRelationship: "Relationship (how you know each other)",
    refsFieldLanguage: "Email language",
    refsColLanguage: "Language",
    refsAddCta: "Add",
    refsFieldsRequired: "Name and email are required",
    refsAdded: "Reference added",
    refsAddFailed: "Add failed",
    refsLoadFailed: "Could not load references",
    refsConfirmDelete: "Delete this reference?",
    refsDeleteFailed: "Delete failed",
    refsUpdateFailed: "Update failed",
    refsEmpty: "No references yet. Add one above.",
    refsColName: "Name",
    refsColContact: "Contact",
    refsColRelationship: "Relationship",
    refsColStatus: "Status",
    refsColActions: "Actions",
    refsInviteCta: "Request as reference",
    refsInviteSent: "Request sent",
    refsInviteFlashHint: "This reference has not been invited yet — click to send",
    refsInviteNowTitle: "Send invite now?",
    refsInviteNowBody: "Do you want to send this reference an invitation email right away? Saves you from forgetting later.",
    refsInviteNowYes: "Yes, send now",
    refsInviteNowNo: "No, later",
    refsInviteFailed: "Send failed",
    refsInviteNoKey: "Email not sent — Resend not configured",
    refsPublicNote: "No references are shown on your public CV. Visitors always see 'References available on request'. Only you actively share the details with an employer.",
    refStatusNoInvite: "No invitation sent",
    refStatusPending: "Pending",
    refStatusApproved: "Approved",
    refStatusDeclined: "Declined by reference",
    refsWaCta: "Share via WhatsApp",
    refsWaMessage: "Hi, would you be my reference for my job search? Fill in your details via this link — it only takes a minute. {url}",
    refsWaOpened: "WhatsApp opened — send the message",
    refsWaFailed: "Could not create share link",
    refsPdfCta: "Download reference list",
    refsPdfTitle: "Generate reference list",
    refsPdfTemplate: "Template (design)",
    refsPdfTemplateDefault: "Default (no template)",
    refsPdfLanguage: "Document language",
    refsPdfIntro: "Intro text",
    refsPdfIntroDefault: "Please find enclosed my references for my job search. Feel free to contact them directly — all of them have agreed.",
    refsPdfSelect: "Which references to include?",
    refsPdfNoApproved: "No approved references yet.",
    refsPdfGenerate: "Generate",
    refsPdfPickAtLeastOne: "Select at least one reference",
    refsPdfDownloaded: "PDF generated",
    refsPdfFailed: "PDF generation failed",

    // Admin emails
    admEmails: "Emails",
    admEmailNote: "Without a RESEND_API_KEY emails are skipped. Get a key at resend.com and add it to the backend configuration.",
    admEmailKindWelcome: "Welcome email",
    admEmailKindReminder: "Trial reminder (2 days)",
    admEmailKindExpired: "Trial expired",
    admEmailKindFollowup: "Follow-up digest",
    admEmailKindPackPurchased: "Pack welcome mail",
    admEmailKindRebuyReminder: "Renewal reminder",
    admEmailKindAffiliatePayout: "Affiliate payout",
    admEmailKindDormantPartner: "Dormant partner nudge",
    admDormantEyebrow: "Dormant partner nudge",
    admDormantTitle: "After how many inactive days should partners get a reminder?",
    admDormantHelp: "Affiliates crossing this threshold with no invite sent and no conversion in that window will receive a weekly reactivation email. Recommended: 30 days. Less aggressive: 45. More aggressive: 14.",
    admDormantUnit: "days",
    admDormantSave: "Save",
    admDormantSaved: "Threshold saved",
    admDormantSaveFailed: "Save failed",
    admEmailTestHint: "Send a test to your own address:",
    admEmailSent: "Test email sent",
    admEmailEmpty: "No emails sent yet.",
    admEmailColKind: "Type",

    // New CV wizard
    rbEditExisting: "Edit existing resume",
    rbNewCv: "Create new resume",
    ncwTitle: "New Resume Wizard",
    ncwCta: "New resume",
    rbSecHobbies: "Hobbies",
    rbHobbyPh: "e.g. Running",
    rbSkillLevelHint: "Click the dots to rate 1 to 5 (5 = excellent) — useful for e.g. languages. Click the same dot again to clear the rating.",
    rbDefault: "Default",
    rbMakeDefault: "Make default",
    rbDefaultSet: "Default resume updated",
    rbSecTemplate: "Template designer",
    rbTemplateHint: "Compose your own resume style — pick a preset or design your own, and preview instantly",
    rbTplPresets: "Preset styles",
    rbTplLayout: "Layout",
    rbTplLayoutLeft: "Sidebar left",
    rbTplLayoutRight: "Sidebar right",
    rbTplLayoutSingle: "Single column",
    rbTplAccent: "Accent colour",
    rbTplAccentCustom: "Custom colour",
    rbTplFont: "Font",
    rbTplFontModern: "Modern (sans-serif)",
    rbTplFontClassic: "Classic (serif)",
    rbTplFontMono: "Typewriter (mono)",
    rbTplDensity: "Density",
    rbTplDenseCompact: "Compact",
    rbTplDenseNormal: "Normal",
    rbTplDenseAiry: "Airy",
    rbTplOptions: "Options",
    rbTplSideBg: "Tinted sidebar",
    rbTplHeaderCenter: "Centered name",
    rbTplRateSkills: "Rating on skills",
    rbTplRateLanguages: "Rating on languages",
    rbTplSkillBullets: "Skill bullet style",
    rbTplSkillBulletNone: "None",
    rbTplSkillBulletDot: "Dot",
    rbTplSkillBulletSquare: "Square",
    rbTplSkillBulletDash: "Dash",
    rbTplSkillBulletArrow: "Arrow",
    rbTplPhoto: "Photo",
    rbTplShowPhoto: "Show photo",
    rbTplShape_square: "Square",
    rbTplShape_rounded: "Rounded",
    rbTplShape_circle: "Circle",
    rbTplPhotoHint: "Drag the ‘Photo’ section to the desired spot · upload it via Your profile",
    rbTplBgTitle: "Background image",
    rbTplBgHint: "Fills the entire A4 page of the CV, on every page.",
    rbTplBgUpload: "Upload background",
    rbTplBgReplace: "Replace",
    rbTplBgRemove: "Remove",
    rbTplBgOpacity: "Opacity",
    rbTplBgOpacityHint: "0% = invisible, 100% = fully opaque. 10–25% usually keeps text most readable.",
    rbTplBgFormats: "PNG, JPG or WEBP · max 4 MB",
    rbTplBgPresetsTitle: "Preset backgrounds",
    rbTplBgPresetPaper: "Paper",
    rbTplBgPresetGrid: "Grid",
    rbTplBgPresetDots: "Dots",
    rbTplBgPresetGradient: "Gradient",
    rbTplBgMyPresetsTitle: "Your backgrounds",
    rbTplBgSavePreset: "Save as preset",
    rbTplBgSavePrompt: "Give this background a name:",
    rbTplBgSaveDefaultName: "My background",
    rbTplBgSaved: "Background saved",
    rbTplBgSaveFailed: "Save failed",
    rbTplSections: "Section placement",
    rbTplSectionsHint: "Drag sections between the header, sidebar and main column, or reorder them",
    rbTplSectionsHintSingle: "Single column: drag to set the order (top zone comes first)",
    rbTplZoneSide: "Sidebar",
    rbTplZoneMain: "Main column",
    rbTplZoneTop: "At the top",
    rbTplZoneBottom: "Below",
    rbDndLanguages: "Languages",
    rbTplSavedTitle: "Saved templates",
    rbTplNamePh: "e.g. My business style",
    rbTplSaveBtn: "Save template",
    rbTplNameRequired: "Give the template a name first",
    rbTplSaved: "Template saved",
    rbTplApply: "Use",
    rbTplApplied: "Template applied to this resume",
    rbTplPickHint: "Pick a style for this resume — create and manage your own templates under ‘My templates’ in the menu",
    rbTplManageHint: "Want to create or edit templates? Go to ‘My templates’ in the menu",
    navTemplates: "My templates",
    tmSubtitle: "Your resume & letter styles",
    tmHint: "Design a template and pick it when creating a resume or motivation letter",
    tmNewBtn: "New template",
    tmEmptyTitle: "No templates yet",
    tmEmptyHint: "Create your first template and use it for your resume and motivation letter.",
    tmNameLabel: "Template name",
    tmSave: "Save template",
    tmSaved: "Template saved",
    tmCancel: "Back",
    tmEdit: "Edit",
    tmEditTitle: "Edit template",
    tmNewTitle: "New template",
    tmDeleteConfirm: "Delete this template?",
    tmDeleted: "Template deleted",
    tmPreviewHint: "Preview based on your default resume or sample data",
    tplDefaultOption: "Default style (Classic)",
    ncwTemplateLabel: "Pick a template (optional)",
    ltwTemplate: "Pick a style for your letter and attachments",
    ltwTemplateHint: "Optional — the template sets the font and accent colour of the letter PDF",
    ltwTplFromCv: "Same style as the selected resume",
    rbTplZoneHeader: "Header",
    tplSecStyle: "Section style",
    tplSecBorder: "Border (line)",
    tplSecBorderOn: "On",
    tplSecFill: "Fill colour",
    tplSecTextColor: "Text colour",
    tplSecTitleColor: "Title colour",
    tplSecNone: "None",
    tplSecHint: "Brush = colours & border per section · eye = hide section · drag = move",
    tplSecHide: "Hide section",
    tplSecShow: "Show section",
    tmLivePreview: "Live preview",
    rbEduLevel: "Level",
    rbEduLevelPh: "e.g. BSc",
    dashDocs: "Documents for this application",
    dashDocsTitle: "For this application",
    dashDocsCv: "Resume (PDF)",
    dashDocsLetter: "Motivation letter",
    dashDocsValidation: "Requirement validation",
    dashDocsPackage: "Application package",
    dashDocsSectionUploaded: "Uploaded attachment",
    dashDocsSectionLetter: "Cover letter bundle",
    dashDocsJobCv: "Attached CV",
    dashDocsEmpty: "No attachments yet — attach a CV or generate a cover letter.",
    fuTitle: "Update follow-up",
    fuHow: "How did you follow up?",
    fuMethodEmail: "Email",
    fuMethodPhone: "Called",
    fuMethodNote: "Note",
    fuNotePh: "e.g. Spoke to the recruiter — will call back next week",
    fuResetHint: "Logging restarts the follow-up counter and pauses the reminders",
    fuSave: "Log follow-up",
    fuSaved: "Follow-up logged — counter restarted",
    fuHistory: "Follow-up log",
    fuNoHistory: "No follow-up actions logged yet",
    fuAuto: "automatic",
    pageInfo: "Page {page} of {total}",
    pagePrev: "Previous",
    pageNext: "Next",
    shareTitle: "Shareable resume link",
    shareHint: "Put your resume online on your own link — great for your LinkedIn bio or email signature",
    shareEnable: "Turn my resume link on",
    shareTurnOff: "Turn link off",
    shareSlugLabel: "Your link",
    shareCvLabel: "Which resume do you share?",
    shareContactLabel: "Show contact details on the public page",
    shareSave: "Save settings",
    shareSaved: "Share link updated",
    shareDisabled: "Your resume page is now offline",
    shareCopy: "Copy link",
    shareCopySocial: "Social link (with preview)",
    shareCopySocialHint: "Use this link on LinkedIn/WhatsApp — shows name, title and photo as a preview",
    shareCopied: "Link copied",
    shareFieldsLabel: "Which details do you share on the public page?",
    shareFieldsHint: "Name and job title are always shown — you decide the rest",
    rbPersonalFieldsLabel: "Which personal details appear on this resume?",
    rbPersonalFieldsHint: "Disabled details will not appear on this resume's PDF",
    rbPersonalNoneFilled: "Your profile has no personal details yet. Fill them in first via Profile → Personal details; the chips to show or hide each field will appear here afterwards.",
    ppEmailPrefs: "Email preferences",
    ppDigestLabel: "Weekly progress email",
    ppDigestHint: "A calm weekly overview: new applications, interviews and who is awaiting follow-up",
    ppDigestOn: "Weekly progress email is on",
    ppDigestOff: "Weekly progress email is off",
    ppFollowupsLabel: "Follow-up reminders",
    ppFollowupsOn: "Follow-up reminders are on",
    ppFollowupsOff: "Follow-up reminders are off",
    ppTrashRemindersLabel: "Trash-bin warnings",
    ppTrashRemindersOn: "Trash-bin warnings are on",
    ppTrashRemindersOff: "Trash-bin warnings are off",
    ppArchiveExpiryLabel: "Archive expiry warning",
    ppArchiveExpiryHint: "Email 30 days before an archived application auto-deletes, with a direct download link.",
    ppArchiveExpiryOn: "Archive expiry warning is on",
    ppArchiveExpiryOff: "Archive expiry warning is off",
    // Testimonials submission section on profile
    tsEyebrow: "YOUR STORY",
    tsTitle: "Share your JobGrid experience",
    tsBody: "Write a short quote about how JobGrid helped you. Once approved, your story rotates automatically on the posters our partners print.",
    tsSubmitCta: "Share your quote",
    tsEmpty: "You haven't submitted a quote yet. Share your story in under a minute and help others.",
    tsLoading: "Loading…",
    tsStatusPending: "In review",
    tsStatusApproved: "Approved",
    tsStatusRejected: "Rejected",
    tsAnonymous: "Anonymous",
    tsWithdraw: "Withdraw",
    tsWithdrawnDone: "Submission withdrawn",
    tsWithdrawFailed: "Withdraw failed",
    ppSendSample: "Send me a sample",
    ppSampleSent: "Sample sent — check your inbox",
    ppSampleFailed: "Sending failed — is the domain verified in Resend?",
    ppMembership: "Membership",
    ppMemStatusLabel: "Status",
    ppMemTrial: "Trial period",
    ppMemActive: "Active subscription",
    ppMemExpired: "Expired",
    ppMemAdmin: "Admin · Unlimited",
    ppMemAdminPlan: "Unlimited",
    ppMemPlanLabel: "Plan",
    ppMemPlanMonthly: "Monthly · €9.95/month",
    ppMemPlanYearly: "Yearly · €79/year",
    ppMemPlanTrial: "Free trial",
    ppMemUntil: "Valid until",
    ppMemDaysLeft: "{days} days left",
    ppMemCancelledNote: "Cancelled — you keep access until the end date, nothing renews after that.",
    ppMemCancelBtn: "Cancel subscription",
    ppMemCancelConfirm: "Are you sure you want to cancel your subscription? You keep access until the end date.",
    ppMemCancelDone: "Your subscription has been cancelled",
    ppMemUpgrade: "Upgrade now",
    ppMemCancelHint: "Cancel monthly — cancelling stops renewal, your access remains until the end date.",
    ppInvoices: "Invoices",
    ppInvoicesHint: "Your Stripe payments — download each invoice as PDF",
    ppNoInvoices: "No invoices yet.",
    ppInvoiceDl: "Download",
    shareOpen: "View page",
    shareViews: "{n} views",
    pubDownload: "Download PDF",
    pubNotFound: "This resume page does not exist (anymore).",
    pubMadeWith: "This resume was made with",
    pubCta: "Create yours too — try for free",
    priceSaveBadge: "Save 34%",
    priceSaveBanner: "Yearly access: €79 instead of €119.40 — 34% off",
    rbPersonalFromProfile: "Address, email, phone, date of birth and photo are managed centrally under ‘Your profile’ — they are used automatically on every resume PDF.",
    navProfile: "Your profile",
    ppTitle: "Your profile",
    ppHint: "These details are used automatically on every resume PDF.",
    ppData: "Personal details",
    ppBirthdate: "Date of birth",
    ppBirthdatePh: "e.g. 12-05-1988",
    ppPhotoHint: "Appears at the top of your resume (pick the shape in the Template designer) · JPG/PNG/WEBP, max 5 MB",
    rbTplClassic: "Classic",
    rbTplClassicHint: "Monochrome, businesslike",
    rbTplModern: "Modern",
    rbTplModernHint: "Petrol accent with tinted sidebar",
    rbTplElegant: "Elegant",
    rbTplElegantHint: "Serif with golden accents",
    rbPreview: "Preview",
    rbPreviewTitle: "PDF preview",
    rbPreviewBusy: "Generating…",
    rbPreviewRefresh: "Refresh",
    rbPhoto: "Photo (optional)",
    rbPhotoUpload: "Upload photo",
    rbPhotoRemove: "Remove photo",
    rbPhotoHint: "Appears at the top of the PDF sidebar · JPG/PNG/WEBP, max 5 MB",
    rbPhotoUploaded: "Photo saved",
    rbPhotoRemoved: "Photo removed",
    rbAutosaving: "Saving…",
    rbAutosavePending: "Changes…",
    rbAutosaved: "Saved",
    rbPreviewHide: "Hide",
    rbPreviewShow: "Show preview",
    emwTitle: "Email the vacancy poster",
    emwTo: "To (email address)",
    emwToPh: "recruiter@company.com",
    emwAttach: "What do you send along?",
    emwAttachCv: "Resume (PDF)",
    emwAttachLetter: "Motivation letter (PDF)",
    emwAttachPackage: "Application package (PDF)",
    emwNoLetter: "No motivation letter linked to this application yet — create one via the letter wizard first.",
    emwPitchAttach: "Include video-pitch link",
    emwPitchAttachIntro: "Watch my short video pitch:",
    emwPitchSrcLetter: "Vacancy pitch",
    emwPitchSrcFavorite: "Favorite pitch",
    emwPitchSrcElevator: "Elevator pitch",
    emwSubject: "Subject",
    emwBody: "Email text (editable)",
    emwGenerating: "Generating standard text…",
    emwRegenerate: "Regenerate",
    emwOpenMail: "Open in email client",
    emwAttachHint: "The selected PDFs have been downloaded — attach them to the email.",
    emwGenerateFailed: "Generation failed — try again",
    emwType: "Email type",
    emwTypeIntro: "Introduction",
    emwTypeFollowup: "Follow-up",
    emwStaleHint: "This application has had no response for {days} days — a follow-up email is suggested.",
    ncwStep1: "Step 1 · What do you want to start from?",
    ncwStep2: "Step 2 · What do you take over?",
    ncwStep3: "Step 3 · Personal details",
    ncwStep4: "Step 4 · Resume title",
    ncwStep5: "Step 5 · Save as",
    ncwDone: "Your resume variant is ready!",
    ncwBaseExisting: "Based on an existing resume variant",
    ncwBaseExistingHint: "Duplicate a resume you already made and only tweak what needs to be different. Ideal for quickly tailoring towards one specific job.",
    ncwBaseNew: "Build completely new",
    ncwBaseNewHint: "Start with an empty variant and fill in everything yourself. Pick this for a fresh profile or when you want to start from scratch.",
    ncwBaseCentral: "From my central CV (AI)",
    ncwBaseCentralHint: "AI reads your previously uploaded central CV and converts it into editable sections. Pick this if you already stored a CV in your profile.",
    ncwBaseFile: "From a new file (AI)",
    ncwBaseFileHint: "Upload a PDF or DOCX (LinkedIn export works too) and let AI populate the sections. Pick this if your CV lives outside JobGrid.",
    ncwPickBase: "Choose the base variant",
    ncwTakeAll: "Take over everything",
    ncwTakeAllHint: "Profile, experiences, skills, education — the lot",
    ncwTakeSome: "Select parts myself",
    ncwTakeSomeHint: "Pick which experiences and skills to include",
    ncwSelectExp: "Work experiences",
    ncwSelectSkills: "Skills",
    ncwShowFull: "Show full personal details",
    ncwShowFullHint: "Address, phone, email and LinkedIn on the PDF",
    ncwShowNameOnly: "Only my name",
    ncwShowNameOnlyHint: "Contact details are kept off the PDF",
    ncwCvTitleLabel: "Title of this resume (e.g. Project Lead)",
    ncwCvTitlePh: "e.g. Project Lead",
    ncwSaveNameLabel: "Name to save as",
    ncwCreate: "Create resume",
    ncwCreating: "Creating… (AI import may take 20-40 sec)",
    ncwCreatedMsg: "Start the 'Seen a new job?' wizard right away, or are you done?",
    ncwLaunchJob: "Start new job wizard",
    ncwFinish: "Done — open the editor",
    ncwPickBaseFirst: "Choose a base variant first",
    ncwPickFileFirst: "Choose a file first",
    ncwTitleRequired: "Give the resume a title",
    rbShowPersonalToggle: "Show personal details on the PDF",
    njwCta: "Seen a new job?",
    njwTitle: "New job",
    njwStep1: "Step 1 · Where did you see the vacancy?",
    njwStep2: "Step 2 · Check the details",
    njwStep3: "Saved — what would you like to do next?",
    njwManual: "No URL? Enter manually",
    njwViaCrawler: "Via Job Crawler",
    njwViaCrawlerHint: "Search LinkedIn, Indeed, Glassdoor and Adzuna at once — find the job and add it in a single click.",
    njwSaved: "Application saved to the application overview",
    njwActLetter: "Create motivation letter",
    njwActPrep: "Interview preparation",
    njwActDone: "Go to the overview",
    njwSave: "Save to application overview",
    ltDlPackage: "Application package (all-in-one PDF)",

    // Pricing / billing
    priceEyebrow: "Pricing",
    priceTitle: "One calm place for your entire search.",
    priceSubtitle: "Create a free account and keep your applications, CVs and interviews in one place. Only pick an access pack when you want to generate CVs or letters — one-time payment, no auto-renewal. Your data always stays yours.",
    priceTrialBadge: "Access packs",
    priceMonthly: "Monthly",
    priceYearly: "Yearly",
    pricePerMonth: "/month",
    priceOneTime: "one-time",
    pricePackOnlyPerMonth: "€ {amount}/mo · {duration}",
    pricePackDuration: "{duration} of access",
    pricePerYear: "/year",
    priceYearlySave: "Save 34% vs monthly",
    priceBestValue: "Most chosen",
    priceCta: "Start with this plan",
    priceCtaLogin: "Sign in to start",
    priceFeatAll: "Everything included in every pack:",
    priceFeat1: "Unlimited application tracking with archived job descriptions",
    priceFeat2: "AI Resume Builder with multiple variants (PDF in NL, EN, DE, FR, ES)",
    priceFeat3: "AI motivation letters + requirement validation + application package",
    priceFeat4: "AI interview preparation as PDF",
    priceFeat5: "Bookmarks, notes, interview dates and more",
    priceTrialNote: "Free account · no credit card required.",
    priceVatIncluded: "All prices include 21% VAT.",
    priceCtaPack: "Get started",
    priceDurationDays: "{n} days",
    priceDurationMonth1: "1 month",
    priceDurationMonths: "{n} months",
    priceDurationYear: "1 year",
    pricePerMonthDetail: "≈ €{amount}/mo · {n} months billed",
    priceExpiredFree: "You're now on a Free Account — your data stays intact. Buy an access pack to create and download again.",
    cancelChoiceEyebrow: "Manage access",
    cancelChoiceTitle: "What would you like to do?",
    cancelChoiceSoftTitle: "Switch to Free Account",
    cancelChoiceSoftBody: "Your access ends automatically on {date} and will then convert to a Free Account. Your data stays — you can buy a new pack any time to continue.",
    cancelChoiceHardTitle: "Permanently delete account",
    cancelChoiceHardBody: "All CVs, letters, applications and account data will be irreversibly deleted. This action cannot be undone.",
    cancelChoiceReasonIntro: "We'd love to know why you're leaving — it helps us improve JobGrid. (Optional)",
    cancelChoiceNotePlaceholder: "Optional note…",
    cancelChoiceConfirmSoft: "Confirm cancellation",
    cancelReason_job_found: "I found a job 🎉",
    cancelReason_too_expensive: "Too expensive",
    cancelReason_not_useful: "I'm not using it enough",
    cancelReason_temporary_break: "Temporary break",
    cancelReason_other: "Other",
    common_back: "Back",
    affTabLabel: "Affiliate",
    affPromoEyebrow: "Earn together — up to 15% commission",
    affPromoTitle: "Share JobGrid, earn along",
    affPromoBody: "Become an affiliate and earn up to 15% commission on every pack purchased via your link. Payout as soon as you've accrued €25 — straight to your Dutch or European IBAN. No cost, no minimum, just share what you'd recommend anyway.",
    affPromoCta: "Become affiliate — free",
    affPromoShareOnly: "Just share the link",
    affPromoShareOnlyHint: "No affiliate program required — share JobGrid with friends. When they sign up and pay via your link, you get +14 free trial days on top. No IBAN, no admin.",
    affPromoStatCommission: "Commission per pack",
    affPromoStatCookie: "Cookie window",
    affPromoStatPayout: "Payout from",
    affPromoStatMethod: "Straight to your IBAN",

    // Process flow — how it works
    affFlowEyebrow: "How it works",
    affFlowTitle: "Four steps. Done in two minutes.",
    affFlowStep1T: "Sign up",
    affFlowStep1D: "Enter your name and IBAN — just once. Takes less than a minute.",
    affFlowStep2T: "Share your link",
    affFlowStep2D: "Ready-made banner for your email signature, or one-click share to LinkedIn/WhatsApp/X.",
    affFlowStep3T: "Track your clicks",
    affFlowStep3D: "Realtime dashboard: how many clicked, how many converted, how much you've earned.",
    affFlowStep4T: "Get paid",
    affFlowStep4D: "Request payout in one click from €25. SEPA transfer within 1–2 business days.",

    // Banner preview
    affBannerPreviewEyebrow: "Preview",
    affBannerPreviewTitle: "Here's your banner",
    affBannerPreviewBody: "This is exactly what people will see when you paste the HTML banner in your email signature or blog. Small, discreet, but with a clear call-to-action.",
    affBannerPreviewLabel: "Live preview",
    affBannerPreviewHint: "The link in the preview is inactive — after signing up you'll get a unique tracking URL tied to your account.",

    // For who
    affForWhoEyebrow: "Ideal for",
    affForWho1: "Career coaches",
    affForWho2: "HR professionals",
    affForWho3: "Content creators",
    affForWho4: "Anyone with a network",

    affWizardEyebrow: "Sign up",
    affWizardTitle: "Enter your bank details",
    affWizardIntro: "We need your IBAN so we can pay out your commissions. Name must match the account holder.",
    affFieldName: "Account holder name",
    affFieldIban: "IBAN",
    affFieldBic: "BIC (optional)",
    affPasteIban: "Paste IBAN from clipboard",
    affIbanPasted: "IBAN pasted",
    affIbanPasteFailed: "Couldn't read clipboard",
    affBicAutofilled: "Auto-filled",
    affIbanValid: "Valid {country} IBAN",
    affIbanValidWithBank: "Valid {country} IBAN — {bank}",
    affIbanReasonGeneric: "IBAN looks invalid",
    affIbanReasonCountry: "Country code {country} not (yet) supported",
    affIbanReasonLength: "IBAN has {actual} characters — expected {expected}",
    affIbanReasonFormat: "IBAN contains invalid characters",
    affIbanReasonChecksum: "Check digits don't match — look for typos",
    affWizardSubmit: "Confirm signup",
    affJoinValidationMissing: "Please provide at least your name and IBAN",
    affJoinSuccess: "You're in! You can now share the banner.",
    affJoinFailed: "Signup failed",
    affStatClicks7d: "Clicks (7d)",
    affStatConversions: "Conversions",
    affStatAccrued: "Accrued",
    affStatPaid: "Paid out",
    affPosterAttribution: "Clicks per poster",
    affPosterAttributionHint: "The QR on each poster is tagged per variant, so you see exactly which print pulls its weight.",
    affPosterClassic: "Classic A4",
    affPosterBanner: "Banner A4",
    affPosterQuote: "Quote A4",
    affPosterClicksUnit: "total clicks",
    affPosterConversionsUnit: "conv.",
    affPosterCvrUnit: "CVR",
    affPosterWinnerLabel: "Winner · {v}",
    affPosterWinnerHint: "Best clicks-to-conversion rate over the current window. Reprint this one first.",
    affPayoutProgress: "Payout progress",
    affPayoutCta: "Request payout",
    affPayoutHint: "€{need} more before you can request a payout.",
    affPayoutRequested: "{n} conversions queued — you'll get notified once the SEPA transfer is processed.",
    affPayoutFailed: "Request failed",
    affShareEyebrow: "Share your link",
    affShareIntro: "Anyone who buys a pack within 30 days of clicking this link counts towards your commission.",
    affCopyBanner: "Copy HTML banner",
    affCopyLink: "Copy link",
    affDownloadPoster: "Download A4 poster (PDF)",
    affPosterClassic: "Classic (portrait)",
    affPosterClassicDesc: "A4 portrait for canteens, notice boards and reception desks. Full story with hero, bullets and trust badge.",
    affPosterBanner: "Banner (landscape)",
    affPosterBannerDesc: "A4 landscape for pinboards or walls. Short and powerful — perfect for reading from a distance.",
    affPosterQuote: "Review quote",
    affPosterQuoteDesc: "Testimonial-driven poster with a large pull-quote as hero. Great for coffee corners.",
    affPosterLangLabel: "Poster language",
    affPosterCustomQuoteLabel: "Your own review quote (optional)",
    affPosterCustomQuoteHelp: "Overrides the default testimonial on all 3 variants. Leave empty to keep Sanne's quote.",
    affPosterCustomQuotePlaceholder: "e.g. In one afternoon I finished my CV and lined up 3 interviews…",
    affPosterCustomAttribPlaceholder: "e.g. Mark, 29 · Junior Developer, Amsterdam",
    affPosterDownloading: "Downloading…",
    affPosterDownloadPdf: "Download PDF",
    affPosterEyebrow: "Print-ready posters (A4)",
    affPosterTitle: "Print & pin up — every scan counts",
    affPosterHelp: "Pick a layout, print on A4 and pin it up in canteens, bulletin boards or coworking hubs. Each poster carries your own QR — every scan counts toward your commission.",
    affPosterClassic: "Classic (portrait)",
    affPosterBanner: "Banner (landscape)",
    affPosterQuote: "Review quote",
    affPosterDownloaded: "Poster downloaded — pin it up for extra scans!",
    affPosterDownloadFailed: "Could not download the poster. Please try again.",
    affCopy: "Copy",
    affCopied: "Copied",
    affShareNow: "Share your link now",
    affShareModalEyebrow: "Share your affiliate link",
    affShareModalTitle: "Ready to share your link?",
    affShareModalBody: "Pick a channel — we'll pre-fill a personal, ready-to-send message. The sooner you land your first 3 clicks, the sooner you see your first commission.",
    affShareYourLink: "Your personal link",
    affShareChannels: "Share via",
    affShareLinkedIn: "LinkedIn",
    affShareWhatsApp: "WhatsApp",
    affShareEmail: "Email",
    affShareMessage: "I use JobGrid to keep my job applications organised — AI CVs, cover letters and interview prep in one place. If you're job hunting too, worth a look:",
    affShareEmailSubject: "Job hunt tool I use — might be handy",
    affShareTip: "Tip: LinkedIn also copies your message to the clipboard — paste it as your post body and you're done.",
    affShareDone: "Done",
    affInviteEyebrow: "Or send a personal invite",
    affInviteBody: "JobGrid sends a warm email on your behalf with a short intro and your banner. Perfect for that one colleague you want to personally recommend it to.",
    affInviteNotePlaceholder: "Hey! Thought this might be useful for you.",
    affInviteOptionalNote: "personal note (optional)",
    affInviteSend: "Send mail",
    affInviteSending: "Sending…",
    affInviteSent: "Mail sent to {recipient} ✓",
    affInviteToastSent: "Invite sent!",
    affInviteToastFailed: "Couldn't send invite",
    affBannerCopied: "Banner copied — paste into your Gmail/Outlook signature settings.",
    affBannerCopyFailed: "Copy failed",

    // Affiliate endorsement logo
    affLogoEndorsement: "Recommended by",
    affLogoEyebrow: "Your logo — optional",
    affLogoBody: "Upload your own logo or brand icon and it will appear at the bottom of the banner as «Recommended by <logo>». Ideal for career coaches, HR agencies and content creators who want their name attached to the recommendation.",
    affLogoUploadCta: "Upload logo",
    affLogoReplaceCta: "Replace",
    affLogoRemoveCta: "Remove",
    affLogoUploading: "Uploading…",
    affLogoNone: "No logo yet",
    affLogoHint: "PNG, JPG, WEBP or SVG · max 2 MB · automatically scaled to 400 px wide",
    affDisplayNameEyebrow: "Your name or brand",
    affDisplayNameBody: "Optional — this appears as text next to (or in place of) your logo, under \"Recommended by\" in the banner.",
    affDisplayNamePlaceholder: "e.g. Marketing Studio Amsterdam",
    affDisplayNameSave: "Save",
    affDisplayNameHint: "Max. 60 characters. Leave empty to show only your logo, or only JobGrid.",
    affDisplayNameSaved: "Name saved",
    affDisplayNameError: "Could not save name",
    affLogoTooLarge: "File is too large — max 2 MB",
    affLogoSaved: "Logo saved — your banner has been updated",
    affLogoRemoved: "Logo removed",
    affLogoSaveFailed: "Could not save",
    affLinkCopied: "Link copied",
    affLinkCopyFailed: "Copy failed",
    affPaymentDetails: "Payout details",
    affStripeEyebrow: "New · Faster payouts",
    affStripeUpgradeTitle: "Upgrade to Stripe Connect",
    affStripeUpgradeBody: "Get your commission in minutes instead of days. Verify once via Stripe (passport + IBAN), then payouts run automatically. Your existing IBAN flow keeps working until you switch.",
    affStripeUpgradeCta: "Verify via Stripe →",
    affStripeResumeTitle: "Verification not yet complete",
    affStripeResumeBody: "You started the Stripe verification but haven't finished it. Continue to activate automatic payouts.",
    affStripeResumeCta: "Resume verification →",
    affStripeReadyTitle: "Ready for automated payouts via Stripe",
    affStripeReadyBody: "Future payouts will land automatically in your linked bank account — usually within 1-2 business days.",
    affStripeStartFailed: "Stripe couldn't generate a verification link",
    priceBack: "Back",
    priceExpiredBanner: "Your trial has ended. Pick a plan to continue where you left off.",
    priceStartTrialTitle: "From €7.50 · get started with AI",
    priceStartTrialSub: "Prepare thoroughly for your application: download CVs, write cover letters and practise interviews. Full access to every AI tool, with a limited number of CVs, cover letters and Match Scores per period. Need more than 7 days? Pick a bigger pack for extra headroom.",
    priceStartTrialCta: "See packs",
    priceTrialNoCard: "One-time payment · no auto-renew",
    demoLiveEyebrow: "Live demo · 50 seconds",
    demoPlayCta: "Watch demo with sound",
    demoModalLabel: "JobGrid product demo",
    demoUnmute: "Unmute",
    demoMute: "Mute",
    demoClose: "Close",
    priceTrialInc1: "AI CV downloads (PDF)",
    priceTrialInc2: "AI cover letters",
    priceTrialInc3: "AI Match Score & Interview prep",
    priceTrialInc4: "10 job sources · public CV link",

    // Post-trial Free tier
    priceFreeEyebrow: "Your data always stays yours",
    priceFreeTitle: "Even without an active pack: your work stays safe",
    priceFreeSub: "Trial or pack ended? No problem. Your CVs, cover letters and applications remain saved and downloadable. When you're ready to accelerate again, one click activates a new pack — everything is instantly re-enabled.",
    priceFreeYesTitle: "Keeps working",
    priceFreeYes1: "All existing CVs, letters and applications visible",
    priceFreeYes2: "PDF download of previously saved documents",
    priceFreeYes3: "Favourites and job search",
    priceFreeNoTitle: "Instantly active with a new pack",
    priceFreeNo1: "Generate new CVs + cover letters",
    priceFreeNo2: "AI Match Score & Interview prep",
    priceFreeNo3: "Public CV link + video cover letter",
    priceFreeNo4: "Weekly Match-Radar with fresh vacancies",
    priceOrCommit: "Or pick an access pack directly",
    priceCheckoutFailed: "Failed to start payment — please retry",
    priceCancelMonthly: "Cancel monthly",
    priceCancelNote: "The monthly plan can be cancelled monthly — no commitments, stop whenever you want.",

    paySuccessChecking: "Verifying payment…",
    paySuccessOk: "Payment successful — your subscription is active!",
    paySuccessExpired: "The payment session expired. Please try again.",
    paySuccessTimeout: "Status check is taking too long. Check your email for confirmation.",
    paySuccessError: "Verification failed — please retry or contact support.",
    paySuccessToApp: "Go to the app",
    paySuccessRetry: "Back to pricing",

    subTrialBadge: "Trial · {days} days left",
    subUpgrade: "Upgrade",
    subUpgradeNow: "Upgrade now",
    subAdminLink: "Admin",

    // Admin
    admTitle: "Administration",
    admSubtitle: "Users, trials and subscriptions",
    plnSectionEyebrow: "Admin · Plans",
    plnSectionTitle: "Subscription plans & pricing",
    plnNewCta: "New plan",
    plnRefresh: "Reload",
    plnLoadFailed: "Failed to load plans",
    plnEmpty: "No plans yet.",
    plnNew: "New plan",
    plnEdit: "Edit plan",
    plnName: "Name",
    plnSlug: "Slug (unique code)",
    plnDescription: "Description",
    plnPriceMonthly: "One-time total (€)",
    plnPriceMonthlyHint: "€ {total} one-time for {days} days of access · ≈ € {permonth}/mo",
    plnPriceMonthlyHintEmpty: "Exact amount Stripe charges once at purchase",
    plnPriceYearly: "Legacy yearly price (€ · optional)",
    plnPriceYearlyHint: "Only fill in for legacy plans with a separate yearly price. Leave blank for new one-time packs.",
    plnStripeMonthly: "Stripe price ID (monthly)",
    plnStripeYearly: "Stripe price ID (yearly)",
    plnLimits: "Limits (tick 'Unlimited' · 0 = feature blocked)",
    plnMaxCvs: "Max CV variants",
    plnMaxLetters: "Max letters / month",
    plnMaxApps: "Max applications",
    plnMaxTemplates: "Max templates",
    plnMaxMatchAi: "Max Match-AI actions / month",
    plnMaxLanguages: "Number of languages",
    plnFeatures: "Features",
    plnPublicCv: "Shareable CV link",
    plnAiInterview: "AI Interview prep",
    plnIsDefault: "Default for new accounts",
    plnActive: "Active (visible in pricing)",
    plnSave: "Save",
    plnCancel: "Cancel",
    plnCreated: "Plan created",
    plnUpdated: "Plan updated",
    plnDeleted: "Plan deleted",
    plnSaveFailed: "Save failed",
    plnDeleteFailed: "Delete failed",
    plnConfirmDelete: "Delete '{name}'? Users on this plan will fall back to trial.",
    plnColName: "Plan",
    plnColPrice: "Price",
    plnColCommission: "Affiliate",
    plnCommission: "Affiliate commission",
    plnCommissionHint: "≈ € {euro} per sale paid out to the affiliate",
    plnColLimits: "Limits & features",
    plnColStatus: "Status",
    plnOrderSaved: "Order saved",
    plnOrderFailed: "Failed to save order",
    plnStatusActive: "Active",
    plnStatusInactive: "Off",
    plnEditBtn: "Edit",
    plnDeleteBtn: "Delete",
    plnStripeSyncFailed: "Stripe sync failed",
    pricePlanMaxCvs: "{n} CV variants",
    pricePlanUnlimitedCvs: "Unlimited CVs",
    pricePlanMaxLetters: "{n} letters per month",
    pricePlanUnlimitedLetters: "Unlimited letters",
    pricePlanMaxApps: "{n} applications",
    pricePlanUnlimitedApps: "Unlimited applications",
    pricePlanLangs: "{n} languages (NL, EN, DE, FR, ES)",
    pricePlanPublicCv: "Public shareable CV link",
    pricePlanAiInterview: "AI Interview prep",
    pricePlanMaxDownloads: "{n} PDF downloads per month",
    pricePlanUnlimitedDownloads: "Unlimited PDF downloads",
    priceFree: "Free",
    priceCtaFree: "Activate free plan",
    priceFreeActivated: "Free plan activated!",
    priceMostPopular: "Most popular",
    navFeedback: "Support",
    navTour: "Tour",
    navProductTour: "Product tour",
    // Product Tour video modal (menu + landing banner)
    tourEyebrow: "PRODUCT TOUR · SHORT & PUNCHY",
    tourClipCv: "CV Builder",
    tourClipLetter: "Cover letter",
    tourClipInterview: "Interview coach",
    tourClipRadar: "Match Radar",
    tourSoon: "soon",
    tourClipComingSoon: "This clip is on its way — Matilda is in the studio.",
    tourFooterHint: "Escape to close · Every clip is subtitled",
    tourCloseCta: "Done",
    tourEndTitle: "Ready to try it yourself?",
    tourEndBody: "Create your free account and build your first CV in 3 minutes.",
    tourStartFreeCta: "Start free",
    tourGoDashCta: "Open dashboard",
    tourReplayCta: "Watch again",
    tourShareBtn: "Share link",
    tourShareTitle: "Share this clip",
    tourShareHint: "Copy and share the link — the tour opens automatically on this clip.",
    tourShareCopy: "Copy link",
    tourShareCopied: "Copied!",
    // Two-factor (user profile)
    tfaEyebrow: "Security",
    tfaTitle: "Two-factor authentication",
    tfaBody: "Turn on 2FA to require a 6-digit code from your authenticator app on top of your password. Works with Google Authenticator, Authy, 1Password or Bitwarden — offline, no SMS.",
    tfaStatusOn: "2FA is on",
    tfaStatusOff: "2FA is off",
    tfaOffHint: "Recommended — makes your account far harder to break into.",
    tfaEnableBtn: "Enable 2FA",
    tfaActivatedOn: "Activated on",
    tfaCodesLeft: "{n} backup codes left",
    tfaStep1: "Step 1 · Scan the QR with your authenticator app",
    tfaStep2: "Step 2 · Enter the 6-digit code",
    tfaManualLabel: "Enter manually?",
    tfaConfirming: "Confirming…",
    tfaConfirmBtn: "Confirm & turn 2FA on",
    tfaEnabled: "2FA enabled — save your backup codes somewhere safe!",
    tfaDisabled: "2FA disabled",
    tfaConfirmDisable: "Are you sure you want to disable 2FA? Your account will be less protected.",
    tfaBackupEyebrow: "Save these backup codes",
    tfaBackupTitle: "Your 8 one-time backup codes",
    tfaBackupBody: "Save these codes safely (password manager or print them). They are your only way in if you lose your phone — and each code only works once.",
    tfaCopyAll: "Copy all codes",
    tfaCopiedAll: "All backup codes copied",
    tfaBackupHide: "I saved them — hide",
    tfaDisableTitle: "Disable 2FA",
    tfaDisableHint: "Enter a valid code from your authenticator app to turn 2FA off.",
    tfaDisableBtn: "Disable 2FA",
    tfaErrSetup: "Setup failed",
    tfaErrCode: "Code is invalid",
    // Landing banner
    landTourBadge: "NEW · VIDEO TOUR",
    landTourBannerBody: "See in one minute how you build a tailored CV.",
    landTourCta: "Watch the tour",
    landTourPreviewEyebrow: "PRODUCT TOUR · SNEAK PEEK",
    landTourPreviewTitle: "See what you get — 4 clips of 20 seconds each",
    landTourPreviewHint: "Tap a tile to watch that clip right away",
    navRecommend: "Recommend",

    // Recommend dialog
    recEyebrow: "Recommend",
    recTitle: "Recommend JobGrid to someone?",
    recIntro: "Choose how you'd like to do it. Both share the same site — the only difference is what you get in return.",
    recPlainTitle: "Recommend",
    recPlainBody: "Share JobGrid with a friend, colleague or family member. If someone buys a pack via your link, you get 🎁 14 extra days of access as a thank-you.",
    recAffiliateTitle: "Become a partner & earn commission",
    recAffiliateBody: "Same link, but every paid signup earns you a cash percentage. Great if you share JobGrid often.",
    recAffiliateActiveTitle: "You're already a partner",
    recAffiliateActiveBody: "Head to Your profile → Affiliate for your personal link with commission tracking.",
    recBack: "Back",
    recShareEyebrow: "Share the link",
    recShareTitle: "Share JobGrid",
    recShareIntro: "Send the link via WhatsApp, email or social media.",
    recGiftPromise: "When someone buys a pack via your link, we automatically extend your access by 14 days — you'll get a confirmation email.",
    recThankYou: "Thanks for spreading the word! 💛",
    recShareMessage: "Hi, I use JobGrid to keep my job applications organised, refresh my CV and write motivation letters. Might be useful for you too —",
    recShareEmailSubject: "Check this out: JobGrid — everything for job hunting in one place",
    recCopy: "Copy",
    recCopied: "Copied",
    recLinkCopied: "Link copied — paste it in your message",
    recSwitchToAffiliate: "Did you know you can also earn 15% commission? Become a partner →",
    navTrash: "Trash",
    trashTitle: "Trash bin",
    trashLead: "Deleted items are kept for {days} days. After that they are permanently removed. You can restore them any time within that window.",
    trashEmpty: "Trash is empty",
    trashEmptyHint: "Deleted CVs, cover letters and applications will show up here.",
    trashColLabel: "Name",
    trashColKind: "Type",
    trashColDaysLeft: "Time to restore",
    trashColActions: "Actions",
    trashKind_resume: "CV",
    trashKind_letter: "Letter",
    trashKind_job: "Application",
    trashDaysLeft: "{days} days",
    trashRestore: "Restore",
    trashHardDelete: "Delete permanently",
    trashRestored: "Item restored",
    trashHardDeleted: "Item permanently deleted",
    trashConfirmHard: "Delete permanently? This cannot be undone.",
    trashConfirmEmpty: "Permanently delete all {count} items? This cannot be undone.",
    trashEmptied: "{count} items permanently deleted",
    trashEmptyAll: "Empty trash",
    obStepOf: "Step {current} of {total}",
    obNext: "Next",
    obPrev: "Back",
    obSkip: "Skip",
    obFinish: "Done",
    obStep1Title: "Welcome to JobGrid",
    obStep1Body: "In a few short steps we'll show you how to get the most out of the app: from profile and CV to applications, cover letters and interview prep. Ready? Click 'Next'.",
    obStep2Title: "Start with your profile",
    obStep2Body: "Your personal details (name, address, contact) are auto-filled everywhere. Enter them once and forget about it.",
    obStep3Title: "Pick or design a template",
    obStep3Body: "Decide how your CV looks: font, colour, layout and background. Templates are reusable across every CV variant.",
    obStep4Title: "Invite your references",
    obStep4Body: "Ask former colleagues and managers for a short reference. They confirm via a link and you download them as PDF.",
    obStep5Title: "Build your CV variants",
    obStep5Body: "Create multiple CVs — for instance one for project management and one for consulting. The AI helps with descriptions and summaries.",
    obStep6Title: "Register an application",
    obStep6Body: "Click here to add a new job. Paste the URL and JobGrid auto-fetches title, company and description.",
    obStep7Title: "Generate a cover letter",
    obStep7Body: "For every application you can generate a tailored cover letter in seconds — in five languages.",
    obStepMatchTitle: "Raise your match score",
    obStepMatchBody: "Every cover letter gets a Match-score % against the vacancy. From the letter editor you can open the Match Improvement Wizard: AI gives concrete tips, rewrites your CV (fact-checked against your real experience) and delivers a fresh letter with a higher score. Perfect for lifting a borderline application over the line.",
    obStepPrepTitle: "Prep for the interview with AI",
    obStepPrepBody: "Once you have an application logged, click the star icon next to it in the overview. JobGrid will generate expected questions, strong answers based on your CV, and a conversation playbook — with a PDF download. Walk into the interview prepared.",
    obStep8Title: "Track your pipeline",
    obStep8Body: "The overview shows the status of every application, follow-up reminders and interview dates. Everything in one place.",
    obStep9Title: "Good luck!",
    obStep9Body: "You're ready to start. You can restart this tour any time via the 'Tour' button in the sidebar.",

    // New: JobSearch onboarding steps
    obStepJobSearchTitle: "Find jobs — one place for everything",
    obStepJobSearchBody: "Click 'Find jobs' to search LinkedIn, Indeed, Glassdoor and Adzuna in one go. Add any result to your tracker in one click.",
    obStepJobBrancheTitle: "Filter by industry",
    obStepJobBrancheBody: "The chips below the search bar (IT, Healthcare, Marketing, Sales, …) filter results server-side by industry — perfect for keeping the list focused.",
    obStepJobMatchTitle: "AI match against your CV",
    obStepJobMatchBody: "Click 'Compute match' and Gemini scores every job against your CV. The slider hides jobs below your minimum match (default 50%). Green = strong, amber = decent, red = weak.",
    obStepJobToLetterTitle: "From vacancy to cover letter — in one click",
    obStepJobToLetterBody: "The signature JobGrid flow: spot a good vacancy? Click 'Cover letter' on the result. The vacancy is archived, and the letter wizard opens instantly with title, company and description pre-filled. AI writes a tailored letter — you only need to hit send.",
    obTourEyebrow: "Tour",
    obJumpTo: "Jump to step",

    // Partner tour steps
    obPartner1Title: "Welcome to the partner programme",
    obPartner1Body: "This short tour shows how you earn with JobGrid: share your unique link, add a banner to your email signature and attach your own brand as «Recommended by».",
    obPartner2Title: "Your unique link",
    obPartner2Body: "Everyone who pays within 30 days of clicking this link earns you commission. Share it via LinkedIn, WhatsApp or email — visible on your profile.",
    obPartner3Title: "One-click share",
    obPartner3Body: "The share button opens a modal with ready-made messages for LinkedIn, WhatsApp, X and email. Your link is added automatically.",
    obPartner4Title: "Email signature banner",
    obPartner4Body: "Copy the HTML banner and paste it into your Gmail or Outlook signature settings. Everyone you email sees it.",
    obPartner5Title: "Your logo → «Recommended by»",
    obPartner5Body: "Optional: upload your brand logo and it appears below the banner as 'Recommended by [your logo]'. Ideal for coaches, HR agencies and bloggers.",
    obPartner6Title: "Payouts",
    obPartner6Body: "Once you've accrued €25+, request a payout — automatic via Stripe Connect or manual via IBAN. Good luck!",

    // Partner tour CTA
    affDashEyebrow: "Partner dashboard",
    affDashTitle: "Your partner programme",
    affPartnerTourCta: "Partner programme tour",
    // References editor
    refEditCta: "Edit reference",
    refEditEyebrow: "Reference",
    refEditTitle: "Edit details",
    refEditSaved: "Reference updated",
    refEditSave: "Save",
    refEditShareTitle: "Visible in PDF export",
    refEditShareHint: "Tick the fields that may appear in the shared PDF. Unticked fields stay private to your dashboard.",
    refFormName: "Name",
    refFormEmail: "Email",
    refFormPhone: "Phone",
    refFormRelationship: "Relationship / role",
    refFormRoleTitle: "Role / title",
    refFormCompany: "Company",
    refFormYearsKnown: "Years known",
    refFormNote: "Note / endorsement",
    refField_name: "Name",
    refField_role_title: "Role",
    refField_company: "Company",
    refField_email: "Email",
    refField_phone: "Phone",
    refField_relationship: "Relationship",
    refField_years_known: "Years known",
    refField_note: "Note",
    cancel: "Cancel",
    jobAttTitle: "Attachments",
    recFormsTitle: "Recruiter form",
    recFormsUploadCta: "Fill form",
    recFormsUploadCta2: "Auto-fill",
    recFormsUploadBusy: "AI filling…",
    recFormsUploadHint: "Upload a .docx recruiter form — AI fills the blanks using your letter, requirement validation and chosen references.",
    recFormsEmpty: "No filled forms yet. Upload a recruiter .docx to start.",
    recFormsPickerEyebrow: "New form",
    recFormsPickerTitle: "Select references to include",
    recFormsPickerBody: "AI will fill name, contact details, motivation answers, and work experience from the sollicitatie context. Optionally choose which approved references may be shared.",
    recFormsValPrevTitle: "Requirements ready for auto-fill",
    recFormsValPrevBody: "These come from your Requirements-Validation. When a question in the form matches, the exact answer is reused — 1-on-1 with what the recruiter sees in your validation PDF.",
    recFormsValPrevMore: "Show + {n} more",
    recFormsValPrevEmpty: "No Requirements-Validation available yet — AI will fill open fields using only your CV and letter.",
    recFormsPickRefs: "Approved references",
    recFormsFilled: "{n} fields filled — download starting.",
    recFormsFail: "Fill failed — please try again.",
    recFormsWrongType: "Only .docx files are supported.",
    recFormsDelete: "Delete",
    recFormsDeleteConfirm: "Permanently delete this form?",
    recFormsRowMeta: "{n} fields · {when}",
    recFormsAnalyzeCta: "Analyze with AI",
    recFormsAnalyzing: "AI analyzing…",
    recFormsPreviewEyebrow: "Review & adjust",
    recFormsPreviewBody: "AI detected {n} fields, of which {empty} are still empty. Review, edit as needed, then click 'Confirm & Download'.",
    recFormsPreviewNoFields: "No fillable fields found — this document does not appear to contain blanks.",
    recFormsPreviewFooter: "{n} fields total · {empty} still empty",
    recFormsApplyCta: "Confirm & Download",
    recFormsApplying: "Writing document…",
    recFormsFieldType: "Type",
    recFormsPlaceholderLabel: "Placeholder",
    recFormsFieldPlaceholder: "Answer…",
    recFormsAltHint: "Alternatives",
    recFormsConf_high: "Certain",
    recFormsConf_medium: "Likely",
    recFormsConf_low: "Check",
    recFormsSrc_cv: "From CV",
    recFormsSrc_job: "From vacancy",
    recFormsSrc_ai: "AI-generated",
    recFormsSrc_reference: "From reference",
    recFormsSrc_letter: "From letter",
    recFormsSrc_validation: "From validation",
    recFormsMeetsLabel: "Do you meet this",
    recFormsMeets_ja: "Yes",
    recFormsMeets_nee: "No",
    recFormsMeets_gedeeltelijk: "Partly",
    recFormsSrc_empty: "Empty",
    jobAttCv: "CV",
    jobAttCvNone: "No CV attached",
    jobAttLetter: "Cover letter",
    jobAttLetterNone: "No letter generated yet",
    jobAttValidation: "Requirements validation",
    jobAttValidationReady: "Ready to view",
    jobAttValidationNone: "Created together with the letter",
    jobAttOpen: "Open",
    jobAttDownload: "Download",
    jobAttDownloadFailed: "Download failed — please try again.",
    jobAttUpdated: "Updated",
    ltwSourceMode: "Vacancy source",
    ltwSourceNew: "New",
    ltwSourceExisting: "From applications",
    ltwSearchJob: "Search your applications…",
    ltwPickedJob: "Picked",
    ltwGeneratedWithJob: "Application auto-added to your overview",
    ltwOpenLetter: "Open letter",
    ltwOpenValidation: "Open validation",
    ltwValidationReady: "Requirements validation ready",
    dangerZoneEyebrow: "Danger zone",
    dangerZoneTitle: "Cancel account",
    dangerZoneBody: "Sure you want to leave JobGrid? Choose whether to convert to a free account (your data stays for 12 months after your last login) or permanently delete everything.",
    cancelAccountCta: "Cancel",
    cancelEyebrow: "Account",
    cancelTitle: "Cancel",
    cancelDowngradeTitle: "Convert to free account",
    cancelDowngradeBody: "Your Stripe renewal is stopped and your account remains available for 12 months after your last login. Your CVs, letters and applications stay read-only until then.",
    cancelDowngradeConfirm: "Confirm conversion",
    cancelDeleteTitle: "Delete permanently",
    cancelDeleteBody: "Everything is removed immediately: CVs, cover letters, applications, references and settings. This action is irreversible.",
    cancelDeleteWarning: "This action is irreversible. All data tied to your account will be removed immediately.",
    cancelDeleteConfirm: "Delete permanently",
    cancelDeleteConfirmLabel: "Type '{word}' to confirm",
    cancelReasonLabel: "Reason (helps us improve)",
    cancelNoteLabel: "Note (optional)",
    cancelReasonJobFound: "I found a job",
    cancelReasonTooLittle: "I didn't use it enough",
    cancelReasonExpect: "Didn't meet my expectations",
    cancelReasonOther: "Other",
    cancelDowngradeDone: "Converted to free account",
    cancelDeleteDone: "Account deleted",
    ticketEyebrow: "Feedback",
    ticketTitle: "Report a bug or suggest an improvement",
    ticketKindLabel: "What are you reporting?",
    ticketKindBug: "Bug",
    ticketKindSuggestion: "Suggestion",
    ticketSubjectLabel: "Subject",
    ticketDescriptionLabel: "Description",
    ticketSubjectBugPlaceholder: "e.g. 'Save' button doesn't respond",
    ticketSubjectSuggestionPlaceholder: "e.g. I'd like CSV export",
    ticketDescriptionBugPlaceholder: "Describe what you did, what you expected, and what happened. A screenshot URL is welcome.",
    ticketDescriptionSuggestionPlaceholder: "Describe the feature or improvement you'd like, and why.",
    ticketRequired: "Please fill both fields.",
    ticketSubmit: "Send",
    ticketCancel: "Cancel",
    ticketSent: "Thanks! Your message has been sent.",
    ticketFailed: "Sending failed — please try again.",
    ticketHistory: "Your previous tickets",
    ticketHistoryEmpty: "No tickets yet.",
    ticketAdminReply: "Reply from support",
    ticketStatusOpen: "Open",
    ticketStatusInProgress: "In progress",
    ticketStatusResolved: "Resolved",
    ticketStatusClosed: "Closed",
    ticketAdmEyebrow: "Admin · Tickets",
    ticketAdmTitle: "Bugs & suggestions",
    ticketAdmStatus: "Status",
    ticketAdmReplyLabel: "Reply (visible to user)",
    ticketAdmReplyPlaceholder: "Short reply or update…",
    ticketAdmSave: "Save",
    ticketAdmSaveFailed: "Save failed",
    ticketAdmLoadFailed: "Failed to load tickets",
    ticketAdmEmpty: "No tickets for this filter.",
    ticketStatTotal: "Total",
    ticketStatOpen: "Open",
    ticketStatIn_progress: "In progress",
    ticketStatInProgress: "In progress",
    ticketStatResolved: "Resolved",
    ticketStatBug: "Bugs",
    ticketStatSuggestion: "Suggestions",
    footerCompany: "Contact details",
    footerContact: "Contact",
    contactEyebrow: "Contact",
    contactTitle: "Get in touch",
    contactSubtitle: "Questions, feedback or partnership? Fill the form and we'll reply within 1 business day.",
    contactBack: "Back",
    contactName: "Name",
    contactEmail: "Email",
    contactSubject: "Subject",
    contactMessage: "Message",
    contactSubmit: "Send",
    contactSent: "Thanks — your message has been sent!",
    contactFailed: "Message could not be sent — please try again.",
    contactSuccessTitle: "Sent!",
    contactSuccessBody: "We received your message and will reply within 1 business day.",
    contactSendAnother: "Send another message",
    contactDetailsEyebrow: "Company details",
    ppTicketNotifyLabel: "Email me on ticket updates",
    ppTicketNotifyOn: "Notifications on",
    ppTicketNotifyOff: "Notifications off",
    ppFollowupDaysLabel: "Default follow-up date (days after applying)",
    ppFollowupDaysHint: "New applications get this follow-up date automatically. You can override it per application.",
    admNavOverview: "Overview",
    admNavPlans: "Plans",
    admNavUsers: "Users",
    admNavTickets: "Tickets",
    admNavEmails: "Emails",
    admNavTransactions: "Transactions",
    admNavEvents: "Activity",
    admNavBranding: "Branding",
    admNavSecurity: "Security",
    admNavTestimonials: "Reviews",
    admNavAffiliates: "Affiliates",
    admInvitesEyebrow: "Invite activity",
    admInvitesTitle: "Who's actively sending invites?",
    admCashflowEyebrow: "Cash-flow check",
    admCashflowTitle: "Can you pay out all pending commissions?",
    admCashflowBody: "Compares your live Stripe platform balance against total pending commission. Green = ample buffer, amber = tight, red = shortfall → hold off transfers until new sales settle.",
    admCashflowRefresh: "Refresh",
    admCashflowStripeBalance: "Stripe balance",
    admCashflowPending: "Pending commission",
    admCashflowPendingClearance: "clearing on Stripe",
    admCashflowConversions: "conversions",
    admCashflowGapPositive: "Enough buffer for all payouts",
    admCashflowGapNegative: "Shortfall — new sales needed",
    admCashflowHealthHealthy: "Healthy",
    admCashflowHealthIdle: "None pending",
    admCashflowHealthTight: "Tight",
    admCashflowHealthCritical: "Shortfall!",
    admCashflowErrorHint: "(likely: STRIPE_API_KEY still placeholder — works after deploy)",
    admInvitesBody: "See which affiliates truly work their network and which just sit opted-in. Handy to send targeted follow-up nudges to dormant partners.",
    admInvitesStatSends: "Mails sent",
    admInvitesStatOpens: "Opens",
    admInvitesStatClicks: "Clicks",
    admInvitesStatRecipients: "Unique recipients",
    admInvitesStatActive: "Active senders",
    admInvitesStatDormant: "Dormant partners",
    admInvitesTopSenders: "Top senders",
    admInvitesEmpty: "No invites sent in this window yet.",
    admInvitesEmptyHint: "You have {total} affiliates opted in — consider sending a short reminder that the invite flow is available.",
    admInvitesColAffiliate: "Affiliate",
    admInvitesColSends: "Sends",
    admInvitesColOpens: "Opens",
    admInvitesColClicks: "Clicks",
    admInvitesColRecipients: "Recipients",
    admInvitesColConversions: "Conversions",
    admInvitesColLastSent: "Last",
    admAffTitle: "Affiliate payouts",
    admAffIntro: "All affiliates with pending commissions. Run the SEPA transfer from your bank app, then mark as paid.",
    admAffColAffiliate: "Affiliate",
    admAffColIban: "IBAN",
    admAffColConversions: "Conversions",
    admAffColAmount: "Amount",
    admAffColStatus: "Status",
    admAffColActions: "Actions",
    admAffStatusPending: "Pending",
    admAffStatusRequested: "Requested",
    admAffEmpty: "No open payouts.",
    admAffMarkPaid: "Mark paid",
    admAffPayStripe: "Via Stripe",
    admAffPayStripeConfirm: "Pay out directly via Stripe Connect? The transfer will be sent immediately and marked as paid.",
    admAffStripePaid: "{amount} sent via Stripe ({n} conversions).",
    admAffMarkPaidConfirm: "Mark all open conversions for this affiliate as paid? Only do this after completing the SEPA transfer.",
    admAffMarkedPaid: "{n} conversions marked as paid.",
    admAffCopyIban: "Copy IBAN",
    admAffCopied: "Copied",
    admTsTitle: "Moderate reviews",
    admTsIntro: "Approved reviews appear on the landing page. Deletion is permanent.",
    admTsFilterAll: "All",
    admTsFilterPending: "Pending",
    admTsFilterApproved: "Approved",
    admTsFilterQueue: "Queue",
    admTsFilterRejected: "Rejected",
    admTsStatusRejected: "Rejected",
    admTsReject: "Reject",
    admTsRejected: "Submission rejected",
    admTsNoteLabel: "Note",
    admTsNotePlaceholder: "Short review note (optional)…",
    admTsDeleteHint: "Delete permanently — no undo",
    admTsAnon: "Anonymous",
    admTsQueueEmpty: "Queue is empty — nothing to review.",
    admTsQueueAllClear: "Fresh submissions automatically show up at the top.",
    admTsCatAll: "All categories",
    admTsCatUser: "Users",
    admTsCatPartner: "Partners",
    admTsColAuthor: "Author",
    admTsColQuote: "Quote",
    admTsColRating: "Rating",
    admTsColSubmitted: "Submitted",
    admTsColStatus: "Status",
    admTsColActions: "Actions",
    admTsEmpty: "No reviews in this category.",
    admTsApprove: "Approve",
    admTsDelete: "Delete",
    admTsDeleteConfirm: "Permanently delete this review?",
    admTsApproved: "Review approved — now visible on the landing page.",
    admTsDeleted: "Review deleted.",
    admTsStatusPending: "Pending",
    admTsStatusApproved: "Approved",
    admInsightsTitle: "Last 7 days",
    admInsightsHint: "Rolling window — data refreshes automatically every 5 minutes.",
    admInsightsNewUsers: "New users",
    admInsightsRevenue: "Revenue",
    admInsightsPending: "Open actions",
    admInsightsPerDay: "per day",
    admInsightsSince: "past 7 days",
    admDigestWeeklyCta: "Test weekly digest",
    admDigestWeeklyHint: "Sends the weekly admin summary right now (new users, revenue, open actions) — the same one that goes out every Monday at 08:00 UTC.",
    admDigestWeeklySent: "Weekly digest sent to {n} admin(s).",
    brndTitle: "Logo & Branding",
    brndIntro: "Upload a custom logo (PNG, SVG, JPEG or WebP, max ~500 KB). Applied instantly to every page header — no deploy needed. Reset any time to fall back to the default JobGrid word-mark.",
    brndDefaultLabel: "Default logo active",
    brndActive: "A custom logo is currently active. Replace or reset below.",
    brndInactive: "No custom logo uploaded yet. The default JobGrid word-mark is shown.",
    brndUpload: "Upload logo",
    brndUploadReplace: "Replace logo",
    brndResetCta: "Back to default",
    brndResetConfirmTitle: "Reset logo?",
    brndResetConfirmBody: "The uploaded logo will be removed and the app falls back to the default JobGrid word-mark. This can't be undone (you can always upload again).",
    brndResetConfirmCta: "Yes, reset",
    brndReset: "Logo reset to default.",
    brndUploaded: "Logo updated — now active everywhere.",
    brndHint: "Every upload is automatically resized to 240px (longest edge) — no need for exact dimensions. Upload big and sharp; the result renders crisp on retina screens.",
    brndErrTooLarge: "File is larger than 500 KB — pick a smaller one.",
    brndErrType: "Only PNG, JPEG, SVG or WebP supported.",
    brndErrGeneric: "Upload failed — please retry.",
    brndStripeManual: "Logo uploaded to Stripe. Finish the one-time link in Stripe Dashboard → Settings → Branding so it also appears on invoices.",
    brndStripeOpen: "Open Stripe",
    admEventsRefresh: "Refresh",
    admEventsSearchPlaceholder: "Search events…",
    admEventsEmpty: "No events yet — upgrades and quota hits will appear here.",
    admEventsLevel_all: "All",
    admEventsLevel_info: "Info",
    admEventsLevel_success: "Success",
    admEventsLevel_warn: "Warning",
    admEventsLevel_error: "Error",
    admOverviewEventsTitle: "Recent activity",
    admOverviewEventsAll: "View all",
    admRelJustNow: "just now",
    admRelMinAgo: "{n}m ago",
    admRelHourAgo: "{n}h ago",
    admRelDayAgo: "{n}d ago",
    admBellTooltip: "Notifications",
    admBellTitle: "Recent activity",
    admBellEmpty: "No activity yet — upgrades and quota hits will appear here.",
    plnMaxDownloads: "Max PDF downloads / month",
    plnStatActive: "Active subscribers",
    plnStatActiveShort: "active",
    plnStatMrr: "MRR (monthly)",
    plnStatArr: "ARR (yearly)",
    admForbidden: "Administrators only.",
    admBackToApp: "Back to the app",
    admStatUsers: "Users",
    admStatTrial: "On trial",
    admStatActive: "Active subscriptions",
    admStatExpired: "Expired",
    admStatNew7: "New (7 days)",
    admStatRevenue: "Total revenue",
    admStatRevenue30: "Revenue (30 days)",
    admFilterAll: "All",
    admFilterTrial: "Trial",
    admFilterActive: "Active",
    admFilterExpired: "Expired",
    admFilterAdmin: "Admins",
    admSearchPh: "Search name or email…",
    admColUser: "User",
    admColStatus: "Status",
    admColPlan: "Plan",
    admColTrialEnds: "Trial until",
    admColSubEnds: "Subscription until",
    admColSince: "Since",
    admColActions: "Actions",
    admLabelTrial: "TRIAL",
    admLabelActive: "ACTIVE",
    admLabelExpired: "EXPIRED",
    admLabelAdmin: "ADMIN",
    admLabelFriendsFamily: "F&F",
    admActExtend: "+7d trial",
    admActGrant30: "+30d sub",
    admActGrant365: "+1y sub",
    admActRevoke: "Revoke",
    admActAdmin: "Admin on/off",
    admActBillingExemptOff: "Friends & Family",
    admActBillingExemptOn: "F&F on",
    admActBillingExemptHint: "No payment request — full access without subscription",
    admActReset: "Reset password",
    admActResetHint: "Manually set a new password for this user",
    admActResetPrompt: "New password for {email} (min. 8 chars, letters + digits):",
    admActResetInvalid: "Password must be at least 8 characters and contain both letters and digits.",
    admActResetOk: "Password reset for {email} — ready to use",
    admActionOk: "Updated",
    admActionFailed: "Action failed",
    admTransactions: "Transactions",
    admTxEmpty: "No transactions yet.",
    admNoUsers: "No users found.",
    admDaysLeft: "{days}d left",

    // Landing
    landNavPricing: "Pricing",
    landNavPartner: "Become a partner",
    landNavLogin: "Sign in",
    landH1a: "Find, write, perform —",
    landH1accent: "with AI",
    landH1b: "from vacancy to offer.",
    landSub: "JobGrid scans ten major job platforms in one shot, writes your CV and cover letter to fit, coaches your interview prep and sends a weekly AI Match-Radar with fresh vacancies. All in one calm place — from first click to signed contract.",
    landCtaTrial: "Start 7 days for €5",
    landCtaPricing: "View pricing",
    landFloatTitle: "Today in your ledger",
    landFeaturesEyebrow: "In this issue",
    landFeaturesTitle: "Everything for a considered application.",
    spEyebrow: "Trusted by professionals",
    spHeadline: "Thousands of applicants have already gone before you — with sharper letters, higher match scores and a quieter overview.",
    spQuote1Body: "The Match-score AI gave my letter an 87% and I was invited within a day. I'll never apply without it again.",
    spQuote1Name: "Anna · Utrecht · Marketer",
    spQuote2Body: "Finally one place where all my applications, CV variants and follow-ups live. Deeply calming.",
    spQuote2Name: "Jeroen · Amsterdam · Product Owner",
    spQuote3Body: "The AI-tailored CV saved me hours of rewriting — and the recruiter called back within two days.",
    spQuote3Name: "Layla · Rotterdam · Data Analyst",
    mobStickyTitle: "Apply with care",
    mobStickyHint: "Free account · no credit card",
    mobStickyCta: "Start",
    imwCelebration: "What a jump — your match rose by {delta} points. Ready to send.",
    spShareCta: "Share your story",
    revTitle: "Share your JobGrid experience",
    revIntro: "A short story about how JobGrid helped. Shown on the landing page after moderator approval.",
    revRating: "Rating",
    revBody: "Your quote",
    revBodyPh: "E.g. 'The match AI gave my letter 87% and I was invited within a day.'",
    revAlias: "First name",
    revRole: "Role",
    revCity: "City",
    revMod: "We only show first name, role and city. Moderated within 48h.",
    revSubmit: "Submit for approval",
    revSending: "Sending…",
    revThanks: "Thanks — we'll review your message and publish it once approved.",
    revErrShort: "Tell us a bit more — at least 20 characters.",
    revErrGeneric: "Couldn't send your message — please retry.",
    addPasteText: "Or paste the full vacancy text",
    addPasteTextPh: "Copy a LinkedIn/Indeed vacancy, email or PDF — AI dispatches the fields.",
    addPasteTextHelp: "Handy when there's no URL available. Minimum 60 characters.",
    addParseTextCta: "AI dispatches the fields",
    addParseTextBusy: "AI is reading the vacancy…",
    addParseTextOk: "Fields filled — check them once.",
    addParseTextFail: "AI could not parse the text — please retry or fill in manually.",
    landFeat1T: "Archive every vacancy",
    landFeat1D: "Paste a URL — title, company and text are saved, even if the posting disappears.",
    landFeat2T: "AI Resume Builder",
    landFeat2D: "Multiple resume variants, wizards for experiences and profile, PDF in 5 languages (NL, EN, DE, FR, ES).",
    landFeat3T: "Motivation letters that fit",
    landFeat3D: "Letter + requirement validation tailored to vacancy and resume — downloadable as one application package.",
    landFeat4T: "Interview preparation",
    landFeat4D: "Company insights, pitch and talking points as a clean PDF.",
    landFeat5T: "One calm ledger",
    landFeat5D: "Status, channel, rate, interview dates and notes — nothing forgotten.",
    landFeatRefsT: "References without friction",
    landFeatRefsD: "Manage all your references in one place. Ask for approval with a single click — they decide which details are shared. Your public CV always shows 'References available on request'.",
    landFeat6T: "Vacancy Criteria Match",
    landFeat6D: "How does your resume fit? AI compares your resume against the vacancy requirements and shows per criterion where you stand strong — and what to highlight in your letter.",
    landFeat6Badge: "New",
    landFeat6Match: "Match per criterion",
    landFeatWizardBadge: "Match Improvement Wizard",
    landFeatWizardT: "From average score to top fit — in 4 steps",
    landFeatWizardD: "AI reads the vacancy, pinpoints exactly which wording, experience and phrasing in your resume still has room to grow, rewrites your resume while keeping every fact intact, and generates a fresh motivation letter plus an updated match score.",
    landFeatWizardExample: "Example: you apply for Senior Project Lead (requires bachelor's + Scrum). Your CV lacks the degree but shows 8 years of leadership. The wizard rewrites your profile so your work-and-thinking level is immediately visible — and positions your Agile practice as 'already working that way, certification can follow'. Score: 62% → 89%.",
    landFeatWizardStep1: "Advice with projection",
    landFeatWizardStep2: "CV rewrite (diff)",
    landFeatWizardStep3: "New motivation letter",
    landFeatWizardStep4: "Score before / after",
    landFeatWizardGuard: "AI invents nothing. Every rewrite links back to existing CV lines — fact-checkable.",
    landFeat7T: "Design your own Template",
    landFeat7D: "In a few simple steps you shape your own CV template: choose font, colors, layout and photo frame — and reuse it for every application.",
    landFeat7Badge: "New",
    landFeat7Step1: "Pick a layout",
    landFeat7Step2: "Color & font",
    landFeat7Step3: "Save & use",
    landFeatPortfolioBadge: "Portfolio · unique",
    landFeatPortfolioT: "From project links to a print-ready portfolio book",
    landFeatPortfolioD: "Paste your project URLs and JobGrid crawls each site, grabs screenshots, drafts the project copy with AI and turns it into a magazine-style portfolio with an AI cover. Share as a public link or export as a PDF.",
    landFeatPortfolioBullet1: "Playwright crawls each site — pulls copy, meta and screenshots",
    landFeatPortfolioBullet2: "AI cover (Nano Banana) that matches the palette of your template",
    landFeatPortfolioBullet3: "Responsibilities field: spell out exactly what YOU did on each project",
    landFeatPortfolioBullet4: "Public share link with NL/EN switcher · PDF export in both languages",
    landFeatPortfolioExport: "PDF · Public link · Multi-language",
    landFeat8T: "Apply in five languages",
    landFeat8D: "Dutch, English, German, French or Spanish — JobGrid writes your CV and cover letter in the language the vacancy asks for. No raw Google Translate, no expensive translation agency. AI detects the vacancy language and adapts tone and wording to the local application culture.",
    landFeat8Badge: "USP",
    landFeat8LangsTitle: "Available languages",
    landFeat8Lang1: "Dutch",
    landFeat8Lang2: "English",
    landFeat8Lang3: "German",
    landFeat8Lang4: "French",
    landFeat8Lang5: "Spanish",
    landFeat8Auto: "Vacancy language is detected and the CV is written in that language automatically",
    landPricingTitle: "Pick your access pack · start today",
    landPricingSub: "Start free with the trial, or go straight to a pack for unlimited access. One-time payment, no credit card required, no auto-renewal. Your data always stays yours.",
    landTeaserEntryEyebrow: "Entry · 7 days",
    landTeaserEntryPrice: "one-time",
    landTeaserEntryDuration: "7 days limited access",
    landTeaserBestEyebrow: "Best value · 90 days",
    landTeaserBestDuration: "90 days unlimited · ≈ €25/mo equivalent",
    landPricingCta: "All details & start",
    landFooterAdmin: "Administration",
    landFooterPricing: "Pricing",
    landFooterTag: "A quiet, considered ledger for your job search.",

    // Partner ("Become a partner") — public affiliate landing page
    partnerEyebrow: "Partner programme",
    partnerH1a: "Share JobGrid,",
    partnerH1accent: "earn along",
    partnerH1b: "— without hassle.",
    partnerHeroSub: "Know someone who's job hunting, coach professionals, or have a network of HR folks? Become a JobGrid Partner and earn up to 15% commission on every Access Pack purchased via your link.",
    partnerCtaOpenTab: "Open Affiliate tab",
    partnerCtaLoginToJoin: "Log in to sign up",
    partnerCtaSeePricing: "See the packs",
    partnerCtaNoAccountYet: "No account yet? Create one for free",
    partnerHeroFootnote: "Signup happens through your JobGrid account (Profile → Affiliate). Payouts via SEPA to your own IBAN.",

    partnerCommissionEyebrow: "Commission per sale",
    partnerCommissionSub: "Of every Access Pack sold through your link — from 7-day trials up to full-year packs.",
    partnerFactCookie: "Cookie window",
    partnerFactPayoutFrom: "Payout from",
    partnerDays: "days",

    partnerWhatEyebrow: "What is it?",
    partnerWhatTitle: "A simple affiliate programme for anyone who can genuinely recommend JobGrid.",
    partnerWhatBody1: "JobGrid Partner is our affiliate programme. You get a personal referral link and a ready-made HTML banner (for email signatures, blog posts or newsletters). Anyone who buys a paid Access Pack via your link counts toward your commission.",
    partnerWhatBody2: "No deadlines, no minimum sales, no inventory. You earn a percentage of every successful sale and can request payout as soon as you've accrued €25 — straight to your Dutch or European IBAN.",

    partnerBenefitsEyebrow: "Why become a partner?",
    partnerBenefitsTitle: "Four reasons to start today.",
    partnerBenefit1T: "Up to 15% commission",
    partnerBenefit1D: "You earn a meaningful percentage on every Access Pack — whether it's the 7-day trial or the annual pack. The longer the pack, the higher your payout per conversion.",
    partnerBenefit2T: "30-day cookie window",
    partnerBenefit2D: "Someone clicks your link today and only buys three weeks later? No problem — as long as the purchase happens within 30 days, it counts for you.",
    partnerBenefit3T: "Transparent dashboard",
    partnerBenefit3D: "See clicks, conversions, accrued commission and payout status in your Profile tab. No hidden deductions, no waiting for monthly reports.",
    partnerBenefit4T: "SEPA payout to your own IBAN",
    partnerBenefit4D: "Request a payout in one click once you hit €25. We process the SEPA transfer manually to the IBAN you provided — no middlemen, no fees.",

    partnerHowEyebrow: "How does it work?",
    partnerHowTitle: "Four steps. Done in two minutes.",
    partnerStep1T: "Sign up",
    partnerStep1D: "Log in to JobGrid and open the Affiliate tab in your profile. Enter your name and IBAN — that's it.",
    partnerStep2T: "Share your link or banner",
    partnerStep2D: "Copy your personal referral link or the ready-made HTML banner and paste it into your email signature, blog, LinkedIn post or newsletter.",
    partnerStep3T: "Track your earnings",
    partnerStep3D: "The dashboard shows in real time how many people clicked your link, how many converted, and how much commission you've accrued.",
    partnerStep4T: "Get paid",
    partnerStep4D: "Once you've accrued €25, request payout with one click. You'll be notified automatically as soon as the SEPA transfer has been processed.",

    partnerForWhoEyebrow: "Who is it for?",
    partnerForWhoTitle: "Anyone who would genuinely recommend JobGrid.",
    partnerForWhoSub: "You don't need a massive audience. If you help even one or two people a month with their job search, you can already earn. Popular with:",
    partnerForWho1: "Career coaches and job counsellors",
    partnerForWho2: "Recruiters and HR professionals",
    partnerForWho3: "Content creators (LinkedIn, YouTube, newsletters)",
    partnerForWho4: "CV writers and outplacement agencies",
    partnerForWho5: "Anyone with a network of job seekers",

    partnerSignupEyebrow: "Sign up",
    partnerSignupTitle: "Ready to become a partner?",
    partnerSignupBody: "Signup is only possible from inside your own JobGrid account. That way we can guarantee payouts reach the right IBAN and that you have full access to your personal dashboard.",
    partnerHowToJoinLabel: "How to sign up in 4 steps",
    partnerJoin1: "Log in to JobGrid (or create a free account).",
    partnerJoin2: "Go to your Profile and click the \"Affiliate\" tab.",
    partnerJoin3: "Click \"Become affiliate\" and enter your name and IBAN.",
    partnerJoin4: "Done — your personal link and HTML banner are ready to share.",

    partnerFaqEyebrow: "Frequently asked",
    partnerFaqTitle: "Still have questions?",
    partnerFaq1Q: "Are there any costs involved?",
    partnerFaq1A: "No. Joining is completely free and there are no minimum requirements. You only earn when someone actually buys an Access Pack via your link.",
    partnerFaq2Q: "How much commission do I get exactly?",
    partnerFaq2A: "Up to 20% of the sale price of every Access Pack. The exact commission per pack is visible in your affiliate dashboard. Both short trials and annual packs count.",
    partnerFaq3Q: "When do I get paid?",
    partnerFaq3A: "As soon as your accrued commission is €25 or higher, you can request payout in one click. We usually process the SEPA transfer within a few business days.",
    partnerFaq4Q: "What if someone buys only after a week?",
    partnerFaq4A: "No problem. We use a 30-day cookie. If someone clicks your link today and buys within a month, the conversion goes to you.",
    partnerFaq5Q: "Can I join if I live abroad?",
    partnerFaq5A: "Yes. Any SEPA IBAN (roughly EU + EEA + UK) works. Outside SEPA we unfortunately can't process payouts at the moment.",

    // Partner voices (partner-category testimonials, empty-state invite)
    partnerVoicesEyebrow: "Partners speaking",
    partnerVoicesTitle: "What other partners say about JobGrid.",
    partnerVoicesEmptyTitle: "Share your partner story.",
    partnerVoicesEmptyEyebrow: "Become an ambassador",
    partnerVoicesEmptyBody: "The partner programme is brand new — so your story lands here first. Sign up, earn your first commission, and share via your affiliate dashboard how JobGrid helps your network.",

    // Partner-story CTA in affiliate dashboard
    affStoryEyebrow: "Share your story",
    affStoryTitle: "Enthusiastic about JobGrid Partner?",
    affStoryBody: "Say in one line why it works for you. Once an admin approves it, your quote goes live on the public Partner page — more visibility for you and more signups for JobGrid.",
    affStoryCta: "Share my partner story",

    revTitlePartner: "Share your partner story",
    revIntroPartner: "In up to 400 characters, tell us why JobGrid Partner works for you. Once approved by an admin, we'll place your quote on the public Partner page.",

    // Job search (Adzuna + JSearch)
    navJobSearch: "Find jobs",
    navPortfolios: "Portfolio",
    pfTitle: "My portfolios",
    pfSubtitle: "Bundle your projects into a clickable showcase — with QR code, PDF export and a public share link.",
    pfEmpty: "No portfolios yet",
    pfEmptyHint: "Create your first portfolio to gather your projects.",
    pfNew: "New portfolio",
    pfWizardTitle: "Create a new portfolio",
    pfWizardNameLabel: "Portfolio name",
    pfWizardNamePh: "e.g. My UX work 2026",
    pfWizardTaglineLabel: "Tagline (optional)",
    pfWizardTaglinePh: "One-line pitch for the cover page",
    pfCreate: "Create",
    pfEditorBack: "Back to portfolios",
    pfItemsCount: "{n} projects",
    pfAddItem: "+ Add project",
    pfDownloadPdf: "Download PDF",
    pfShareLink: "Share link",
    pfShareCopied: "Link copied",
    pfPublicHint: "Anyone with this link can view your portfolio without logging in.",
    pfItemNamePh: "Project name",
    pfItemDescLabel: "Project description",
    pfItemDescPh: "Describe the project — problem, approach, outcome…",
    pfItemRespPh: "Responsibilities — what did you do? Role, tasks, outcomes…",
    pfItemRespLabel: "Responsibilities",
    pfItemSkillsLabel: "Top related skills",
    pfItemSkillsHelp: "Pick from your CV skills which apply to this project. Shown as tags on your public portfolio and in the PDF.",
    pfItemSkillsSearchPh: "Filter skills…",
    pfItemSkillsNoCv: "No CV skills found. Add skills under \"My CVs\" first — then you can pick them here.",
    pfItemSkillsNoMatch: "No skill matches.",
    pfItemSkillsLimitReached: "Max 25 skills per project.",
    pfItemSkillsAiCta: "AI suggest",
    pfItemSkillsAiBusy: "AI matching…",
    pfItemSkillsAiEmpty: "AI found no clear match — try expanding your description a bit.",
    pfItemSkillsAiFail: "AI suggestion failed — please try again.",
    pfItemSkillsAiNeedText: "Add a description or responsibilities first.",
    pfItemSkillsAiHint: "Click a suggestion to add it, or accept all at once.",
    pfItemSkillsAiAcceptAll: "Accept all ({n})",
    pfItemSkillsAiAdded: "{n} skills added.",
    pfAiRewriteDesc: "AI description",
    pfAiRewriteResp: "AI responsibilities",
    pfItemUrlPh: "https://... (optional)",
    pfAiRewrite: "AI rewrite",
    pfAiRewriting: "Rewriting…",
    pfCrawlHint: "Fetch website info",
    pfCrawlBusy: "Fetching website…",
    pfImageUpload: "Add image",
    pfImageUploading: "Uploading…",
    pfSaveItem: "Save project",
    pfEditItem: "Edit",
    pfDeleteItem: "Delete",
    pfDeleteConfirm: "Remove this project from the portfolio?",
    pfDeletePortfolio: "Delete portfolio",
    pfDeletePortfolioConfirm: "Are you sure you want to delete this portfolio? This can't be undone.",
    jsEyebrow: "Find jobs",
    jsTitle: "Search jobs without switching tabs",
    jsBody: "We search LinkedIn, Indeed, Glassdoor and Adzuna at once. Add any result to your tracker with one click — the job description is archived automatically.",
    jsFieldQ: "Job title or keyword",
    jsFieldLocation: "Location",
    jsSearch: "Search",
    jsResults: "{n} results",
    jsSources: "Sources",
    jsSourcesLinkedIn: "LinkedIn",
    jsSourcesIndeed: "Indeed",
    jsSourcesGlassdoor: "Glassdoor",
    jsSourcesAdzuna: "Adzuna",
    jsSourcesOther: "Other",
    jsSourcesLegend: "Results are aggregated from the largest job platforms in the Netherlands and Belgium.",
    jsEmptyTitle: "No jobs found for this query.",
    jsEmptyHint: "Try different keywords, a broader location, or adjust the employment-type filters.",
    jsLoadingTitle: "Searching LinkedIn, Indeed and Adzuna…",
    jsLoadingHint: "Combining multiple sources can take a few seconds.",
    jsRefresh: "Refresh",
    jsRefreshHint: "Run a fresh search bypassing the cache",
    jsTabSearch: "Search",
    jsTabFavorites: "Favorites",
    jsFavAdd: "Save",
    jsFavRemove: "Saved",
    jsFavAdded: "Added to favorites",
    jsFavRemoved: "Removed from favorites",
    jsHideCta: "Not for me",
    jsHideDone: "Job hidden — you won't see it again",
    jsHideUndo: "Undo",
    jsHideUndone: "Job visible again",
    jsHideUndoFail: "Couldn't undo",
    jsHideFail: "Couldn't hide job",
    jsSortLabel: "Sort",
    jsSortNone: "Default",
    jsSortHigh: "Match high",
    jsSortLow: "Match low",
    jsSortHint: "Sort results by match percentage",
    jsHideReasonTitle: "Why not for you?",
    jsHideReasonHint: "Optional — helps the AI score similar vacancies lower next time.",
    jsHideReasonSalary: "Salary too low",
    jsHideReasonLocation: "Wrong location",
    jsHideReasonLevel: "Wrong level",
    jsHideReasonWorktime: "Bad work hours",
    jsHideReasonPh: "Or type your own reason…",
    jsHideReasonSubmit: "Hide",
    jsHideReasonSkip: "Skip",
    jsFavError: "Could not update favorite",
    jsFavEmptyTitle: "No favorites saved yet",
    jsFavEmptyHint: "Click the heart on any search result to save it here for later.",
    jsFavCount: "{n} favorites",
    jsFavMatchBody: "Our AI scores every saved favorite against your CV. Scores are cached until you re-run the analysis.",
    jsFavMatchRun: "Match favorites with my CV",
    jsFavMatchRerun: "Re-score favorites",
    jsCoachTitle: "AI tip: which skill or experience would raise your match?",
    jsCoachRun: "Match Coach",
    jsCoachRefresh: "Refresh tip",
    jsCoachThinking: "Thinking…",
    jsCoachLabel: "Match Coach — strengthen this",
    jsCoachFailed: "Coach tip failed — try again",
    jsAddToTracker: "Add",
    jsClickForDetails: "Click for details",
    jsDetailClose: "Close",
    jsDetailExternal: "View at source",
    jsDetailNoBody: "No description available. View the job at the source for the full text.",
    jsAdded: "Added ✓",
    jsAddAndLetter: "+ Motivation letter",
    jsFavPitch: "Video pitch",
    jsFavPitchTitle: "Record a short video pitch for this vacancy (AI drafts your script)",
    jsCueCardsTitle: "Cheat-sheet (3 lines)",
    jsCueCardsCopy: "Copy",
    jsCueCardsCopied: "Cheat-sheet copied",
    jsCueCardsCopyFail: "Copy failed",
    jsCueCardsBusy: "AI is drafting your cheat-sheet…",
    jsCueCardsHint: "Ready to apply? Click 'Video pitch' to record these lines.",
    jsAddAndLetterHint: "Add to tracker and open the letter wizard right away",
    jsAddedToTracker: "«{title}» added to your tracker",
    jsAddFailed: "Could not add job",
    jsOpen: "Open",
    jsSearchFailed: "Search failed — try again",

    // Skip-keywords blocklist
    jsSkipTitle: "Skip words — hide vacancies with these requirements",
    jsSkipHint: "Add words or short phrases you don't want to see in vacancies (e.g. 'HBO', 'certified', 'minimum 5 years'). Vacancies containing any of these in the title or description are hidden.",
    jsSkipCount: "{n} word(s) active",
    jsSkippedBadge: "{n} hidden this search",
    jsSkipPlaceholder: "e.g. HBO",
    jsSkipAdd: "Add",
    jsSkipRemove: "Remove",
    jsSkipSaveFail: "Saving failed",
    jsSkipSugInsightsTitle: "AI suggestions from no_fit analyses",
    jsSkipSugInsightsHint: "recurring gaps in your match insights",
    jsSkipSugCvTitle: "Gaps against your CV",
    jsSkipSugCvHint: "terms often in vacancies but missing from your CV",
    jsSkipSugLoading: "Calculating suggestions…",
    jsSkipSugDismiss: "Never suggest again",
    jsSkipReasonTitle: "Why these vacancies are hidden",
    jsSkipReasonMatched: "matched skip word(s):",

    profSkipTitle: "Dismissed skip suggestions",
    profSkipHint: "Suggestions you told us never to suggest again with ×. Click ↺ to make one eligible again.",
    profSkipCount: "{n} dismissed",
    profSkipLoading: "Loading…",
    profSkipEmpty: "No suggestions dismissed yet.",
    profSkipUndo: "Undo — allow re-suggesting",
    profSkipUndone: "\"{kw}\" is eligible again",
    profSkipUndoFail: "Undo failed",

    // Skip history tab
    jsTabHistory: "History",
    jsHistoryTitle: "Skipped vacancies — history",
    jsHistoryCount: "{n} rows",
    jsHistoryClear: "Clear history",
    jsHistoryClearConfirm: "Are you sure you want to clear the entire skip history?",
    jsHistoryCleared: "Skip history cleared",
    jsHistoryClearFail: "Clearing failed",
    jsHistoryLoading: "Loading history…",
    jsHistoryEmptyTitle: "Nothing skipped yet",
    jsHistoryEmptyHint: "As soon as a search hides vacancies based on your skip-words, they show up here.",
    jsHistoryDate: "Date",
    jsHistoryQuery: "Query",
    jsHistoryJob: "Vacancy",
    jsHistoryMatched: "Match",
    jsHistoryOpenTip: "Click for options to open this vacancy anyway",
    jsRestoreTitle: "This vacancy is hidden",
    jsRestoreIntro: "It was skipped because your search filter blocks these skip-word(s):",
    jsRestoreQuestion: "What do you want to do?",
    jsRestoreOpenOnly: "Just open this vacancy",
    jsRestoreOpenOnlyHint: "Opens the URL in a new tab — your skip-words stay in place.",
    jsRestoreTemp: "Temporarily disable skip-word",
    jsRestoreTempHint: "Stays off for this session so similar vacancies show up now. On reload the skip-word returns.",
    jsRestorePermanent: "Remove skip-word permanently",
    jsRestorePermanentHint: "Pulls the word out of your blocklist for good.",
    jsRestoreCancel: "Cancel",
    jsRestoreDone: "{n} skip-word(s) temporarily disabled for this session",
    jsRestoreDoneOne: "Skip-word «{kw}» temporarily disabled",
    jsRestoreRemovedOne: "Skip-word «{kw}» permanently removed",
    jsBypassBadge: "{n} temporarily off",
    jsBypassClear: "Restore all",
    jsBypassRestored: "Skip-words restored",
    jsBadgeVia: "via",

    // Branche chips
    jsBranches: "Industry",
    jsBrancheAll: "All",
    jsBrancheClear: "clear filter",

    // Employment type chips
    jsEmployment: "Employment",
    jsEmploymentAll: "All",
    jsEmploymentFulltime: "Full-time",
    jsEmploymentParttime: "Part-time",
    jsEmploymentContract: "Freelance / Contract",
    jsEmploymentIntern: "Internship",
    jsEmploymentClear: "clear employment",

    // CV match
    jsMatchTitle: "Match against my CV",
    jsMatchBody: "Our AI compares your active CV to every job listing and returns a per-result match score. Drag the slider to hide jobs below the threshold.",
    jsMatchRun: "Compute match",
    jsMatchRerun: "Recompute",
    jsMatchRunning: "Analysing…",
    jsMatchThreshold: "Min. match {pct}%",
    jsMatchFiltered: "{n} hidden",
    jsMatchNoneAboveThreshold: "No jobs above the match threshold. Lower the slider or refine your search.",
    jsMatchDone: "{n} jobs scored",
    jsMatchFailed: "Match analysis failed",

    // Weekly Match Radar
    jsRadarTitle: "Weekly match radar",
    jsRadarBody: "Turn on and we'll email you the top-5 fresh jobs every Monday with ≥ 70% CV match — based on your current search.",
    // Match Radar Insights (analytics panel above the toggle)
    mrInsightsTitle: "Match Radar · last 30 days",
    mrInsights30dLabel: "Matches (30 days)",
    mrInsightsTrendLabel: "Vs. previous 30 days",
    mrInsightsRunsLabel: "Radar runs",
    mrInsightsLastRun: "Last · {date}",
    mrInsightsNextRun: "Next run · {date}",
    mrInsightsWeeklyLabel: "Weekly trend (last 8 weeks)",
    mrInsightsTopCats: "Top branches",
    jsRadarActiveOn: "Active for «{q}» in {loc}",
    jsRadarOn: "Match radar is on — your first digest arrives Monday",
    jsRadarOff: "Match radar disabled",
    jsRadarNeedQuery: "Run a search first before enabling the radar",
    jsRadarSaveFailed: "Could not save",
    jsRadarUnsubDone: "Match radar disabled — no more weekly updates",

    // Landing highlight (job search)
    landJobsEyebrow: "New · Find jobs",
    landJobsTitle: "Search every major job board from one place",
    landJobsBody: "JobGrid scans LinkedIn, Indeed, Glassdoor, Nationale Vacaturebank, Jobbird, Striive, Twago, Randstad Freelance, Freelance.nl and Adzuna in one go. One click adds a listing to your tracker — the description is archived even if the original link disappears. Save favourites or let the weekly Match-Radar deliver fresh hits to your inbox.",
    landJobsBullet1: "Real-time search across millions of jobs — 10 sources at once",
    landJobsBullet2: "Multi-select filters: industry, employment type, location",
    landJobsBullet3: "AI Match: only vacancies ≥ 50% match with your CV",
    landJobsBullet4: "One click: from vacancy straight into the cover-letter wizard",

    // Dashboard widget promo
    jsWidgetEyebrow: "New",
    jsWidgetTitle: "Find jobs — without switching tabs",
    jsWidgetBody: "Search LinkedIn, Indeed, Glassdoor and Adzuna at once.",
    jsWidgetCta: "Open Job search",

    // Video Cover Letter
    vidOpenCta: "Record video letter",
    vidTitle: "Video Cover Letter · AI-coached pitch",
    vidScriptEyebrow: "Your script (~ {seconds}s spoken)",
    vidScriptHint: "AI drafts a script for this specific vacancy — feel free to edit before you record. Max {seconds} seconds.",
    vidScriptLoading: "AI is writing your script…",
    vidScriptFail: "Could not generate script — please try again",
    vidStartRecord: "Turn on camera & record",
    vidRecord: "Start recording",
    vidStop: "Stop recording",
    vidRetake: "Record again",
    vidUpload: "Upload & AI feedback",
    vidBack: "Back",
    vidPrivacyHint: "Your recording stays private until you share the link.",
    vidCamDenied: "Camera / microphone access denied — please allow in your browser.",
    vidUploadFail: "Upload failed — please try again",
    vidProcessing: "Processing video…",
    vidProcessingHint: "Transcribing with Whisper and scoring with Gemini.",
    vidPreviewInfo: "Recording ready · {seconds}s. Watch it back or record again.",
    vidShareEyebrow: "Share link for the recruiter",
    vidShareHint: "Anyone with this link can play the video — your CV stays private.",
    vidCopy: "Copy",
    vidCopied: "Copied!",
    vidMatchScore: "Vacancy match",
    vidClarity: "Clarity",
    vidStrengths: "Strengths",
    vidTips: "Improvement tips",
    vidTranscript: "Transcript",
    vidDone: "Done",
    vidExistingTitle: "You already have a video letter for this motivation",
    vidExistingBody: "A new recording does not automatically replace the old one —",
    vidExistingOpen: "watch current video letter",
    vidDelete: "Delete",
    vidDeleteConfirm: "Permanently delete this video letter? The share link becomes invalid immediately.",
    vidDeleted: "Video letter deleted",
    vidDeleteFail: "Delete failed",

    // Video Cover Letter — public playback
    vidPublicEyebrow: "Video cover letter",
    vidPublicTitle: "A video letter — just for you",
    vidPublicFooter: "Delivered via JobGrid — the calm job-application tool.",
    vidPublicMissing: "This video letter is no longer available",
    vidPublicMissingHint: "The applicant may have removed it or the link is not correct.",
    vidPublicIdentifyTitle: "Who's watching? (optional)",
    vidPublicIdentifyHint: "Leave your name or company — the applicant will see who watched their pitch.",
    vidPublicIdentifyNamePh: "First + last name",
    vidPublicIdentifyCompanyPh: "Company",
    vidPublicIdentifyCta: "Confirm",
    vidPublicIdentifySaved: "Thanks — watching as {name}",

    // Owner-side analytics
    vidStatsTitle: "Who watched your pitch?",
    vidStatsRefresh: "Refresh",
    vidStatsRefreshing: "Refreshing…",
    vidStatsViews: "Views",
    vidStatsIdentified: "Identified",
    vidStatsAnon: "Anonymous",
    vidStatsTop: "Longest watchers",
    vidStatsAnonRow: "Anonymous viewer",
    vidStatsEmpty: "No views yet — share the link with a recruiter.",
    vidStatsAnonOnly: "All views were anonymous — recruiters can leave their name on the public page.",

    // Auto-cue teleprompter
    vidAutoCueEyebrow: "Auto-cue — read along",
    vidAutoCueEmpty: "No script available — draft one in the wizard.",
    vidAutoCueStart: "Start",
    vidAutoCuePause: "Pause",
    vidAutoCueRedo: "Restart",

    // QR-code hint on success screen
    vidQrEyebrow: "QR code on your cover letter",
    vidQrHint: "We automatically add a QR code to the footer of your cover-letter PDF. Recruiters scan it with their phone and go straight to your video pitch.",

    // Elevator-pitch mode
    vidElevatorTitle: "Elevator pitch · generic video letter",
    vidElevatorEyebrow: "Elevator pitch",
    vidElevatorCardTitle: "Record one 60-second pitch",
    vidElevatorCardBody: "This video is automatically linked (as a QR) to your CV and to every cover letter without its own video. Ideal for firing off multiple applications quickly.",
    vidElevatorCta: "Record elevator pitch",
    vidElevatorReplace: "Replace elevator pitch",
    vidElevatorHasOne: "Active elevator pitch — already viewed {views} time(s).",
    vidViewCount: "Viewed {n} time(s) by recruiters",

    // Custom QR-label
    vidQrLabelTitle: "QR label on PDF",
    vidQrLabelHint: "This text shows beneath the QR code on your CV and cover letter. Leave empty to use the default for your language.",
    vidQrLabelPlaceholder: "e.g. Watch my 60s pitch",
    vidQrLabelSave: "Save",
    vidQrLabelSaving: "Saving…",
    vidQrLabelSaved: "QR label saved",
    vidQrLabelFail: "Saving QR label failed",

    // ThinkingLoader — playful rotating status copy for long AI tasks.
    thinkMatch1: "Reading your CV thoroughly…",
    thinkMatch2: "Cataloguing your skills…",
    thinkMatch3: "Ticking off vacancies one by one…",
    thinkMatch4: "Picking up the red pencil…",
    thinkMatch5: "Crunching match scores…",
    thinkMatch6: "Taking a second look…",
    thinkMatch7: "Almost there — dotting the i's…",

    thinkLetter1: "Parsing the vacancy…",
    thinkLetter2: "Spotting your strengths…",
    thinkLetter3: "Tuning voice and tone…",
    thinkLetter4: "Polishing sentences…",
    thinkLetter5: "Tightening paragraph structure…",
    thinkLetter6: "Final touches on your letter…",

    thinkPrep1: "Googling the company…",
    thinkPrep2: "Unpacking mission & culture…",
    thinkPrep3: "Cooking up smart interview questions…",
    thinkPrep4: "Preparing STAR answers…",
    thinkPrep5: "Mapping potential pitfalls…",
    thinkPrep6: "Tailoring coaching tips…",

    thinkInsight1: "Scanning the vacancy text…",
    thinkInsight2: "Naming your strengths…",
    thinkInsight3: "Flagging any gaps…",
    thinkInsight4: "Drafting the verdict summary…",
    thinkInsight5: "Almost there — insight nearly ready…",

    thinkBulk1: "Gathering vacancies…",
    thinkBulk2: "Scoring each match…",
    thinkBulk3: "Putting AI to work — this can take a moment…",
    thinkBulk4: "Hang tight, several vacancies at once…",
    thinkBulk5: "Assembling the report…",
    thinkBulk6: "Almost done — bundling results…",

    thinkResume1: "Organising experience & skills…",
    thinkResume2: "Writing punchy bullets…",
    thinkResume3: "Polishing the language…",
    thinkResume4: "Cutting filler words…",
    thinkResume5: "Checking best-practice structure…",
    thinkResume6: "Final touches on your CV…",

    thinkEmail1: "Deciding tone & greeting…",
    thinkEmail2: "Summarising the core message…",
    thinkEmail3: "Polishing sentences…",
    thinkEmail4: "Almost sent — one more moment…",

    thinkGeneric1: "One moment — I'm working on it…",
    thinkGeneric2: "One or two more steps…",
    thinkGeneric3: "Almost done…",
    thinkGeneric4: "Doing my best — nearly there…",
    thinkGeneric5: "Just a little longer…",
};

export default en;
